<template>
  <div id="ResponsiveCss">
    {{ ActDescBtn }}
    <v-dialog v-if="modoIa" v-model="dialogAnalisisIa" persistent max-width="1400">
      <v-card>
        <v-card-title class="indigo white--text">
          Registro de Facturas IA
          <v-spacer></v-spacer>
          <v-btn icon dark :disabled="analizandoFacturaIa" @click="dialogAnalisisIa = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-file-input v-model="seleccionArchivosFacturaIa" multiple
            accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
            :label="etiquetaCargaFacturaIa" outlined dense show-size
            :disabled="analizandoFacturaIa || validandoCalidadFacturaIa || !puedeAgregarArchivosFacturaIa"
            prepend-icon="fa-file-invoice" :hint="ayudaCargaFacturaIa" persistent-hint
            @change="manejarSeleccionArchivosFacturaIa"></v-file-input>
          <v-progress-linear v-if="validandoCalidadFacturaIa" indeterminate color="indigo" class="mb-2"></v-progress-linear>
          <v-alert type="info" dense outlined class="mt-2 mb-3">
            <div>• Máximo {{ maximoPaginasFacturaIa }} fotos (JPG/PNG) o 1 PDF.</div>
            <div>• No mezcle PDF con fotos en el mismo envío.</div>
            <div>• Tamaño máximo: {{ formatearTamanoArchivoIa(tamanoMaximoBytesFacturaIa) }}.</div>
          </v-alert>
          <v-alert v-if="paginasFacturaIa.length && tipoArchivoFacturaIa === 'IMAGEN'" type="success" dense outlined
            class="mb-3">
            {{ paginasFacturaIa.length }} foto(s) listas.
            Tamaño actual: {{ formatearTamanoArchivoIa(tamanoTotalPaginasFacturaIa) }}
            / {{ formatearTamanoArchivoIa(tamanoMaximoBytesFacturaIa) }}.
          </v-alert>
          <v-row>
            <v-col cols="12" md="7" class="pt-0">
              <div :class="{ 'overflow-y-auto': $vuetify.breakpoint.mdAndUp }"
                :style="$vuetify.breakpoint.mdAndUp ? { maxHeight: 'calc(100vh - 265px)' } : {}">
                <v-card v-if="tipoArchivoFacturaIa === 'IMAGEN' && paginaFacturaIaActiva" outlined>
                  <v-card-subtitle class="py-2">
                    <strong>Página {{ indicePaginaFacturaIa + 1 }}:</strong>
                    {{ paginaFacturaIaActiva.nombre }}
                    — {{ formatearTamanoArchivoIa(paginaFacturaIaActiva.tamano) }}
                  </v-card-subtitle>
                  <v-divider></v-divider>
                  <v-img :src="paginaFacturaIaActiva.url" contain max-height="650"
                    class="grey lighten-3" alt="Vista previa de la página de factura"
                    @error="manejarErrorVistaImagenFacturaIa"></v-img>
                </v-card>
                <v-card v-if="tipoArchivoFacturaIa === 'PDF' && paginaFacturaIaActiva" outlined>
                  <v-card-subtitle class="py-2">
                    <strong>{{ paginaFacturaIaActiva.nombre }}</strong>
                    — {{ formatearTamanoArchivoIa(paginaFacturaIaActiva.tamano) }}
                  </v-card-subtitle>
                  <v-divider></v-divider>
                  <v-toolbar flat dense color="grey lighten-3">
                    <v-btn icon :disabled="paginaPdfFacturaIa <= 1" @click="paginaPdfFacturaIa -= 1">
                      <v-icon>fa-chevron-left</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <strong>Página {{ paginaPdfFacturaIa }} de {{ totalPaginasPdfFacturaIa || "..." }}</strong>
                    <v-spacer></v-spacer>
                    <v-btn icon
                      :disabled="!totalPaginasPdfFacturaIa || paginaPdfFacturaIa >= totalPaginasPdfFacturaIa"
                      @click="paginaPdfFacturaIa += 1">
                      <v-icon>fa-chevron-right</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-progress-linear v-if="cargandoPdfFacturaIa" indeterminate color="indigo"></v-progress-linear>
                  <div class="overflow-y-auto grey lighten-3" style="max-height: 650px">
                    <VuePdfEmbed ref="pdfFacturaIa" :source="paginaFacturaIaActiva.url" :page="paginaPdfFacturaIa"
                      @rendered="manejarPdfFacturaIaRenderizado"
                      @loading-failed="manejarErrorVistaPdfFacturaIa" />
                  </div>
                </v-card>
                <v-alert v-if="errorVistaPreviaFacturaIa" type="error" dense outlined>
                  {{ errorVistaPreviaFacturaIa }}
                </v-alert>
              </div>
            </v-col>
            <v-col cols="12" md="5" class="pt-0">
              <div :class="{ 'overflow-y-auto': $vuetify.breakpoint.mdAndUp }"
                :style="$vuetify.breakpoint.mdAndUp ? { maxHeight: 'calc(100vh - 265px)' } : {}">
                <v-alert v-if="!puedeAgregarArchivosFacturaIa && tipoArchivoFacturaIa === 'IMAGEN'" type="warning"
                  dense outlined>
                  Alcanzó el máximo de {{ maximoPaginasFacturaIa }} fotos. Quite alguna página para agregar otra.
                </v-alert>
                <v-card v-if="paginasFacturaIa.length" outlined class="mb-3">
                  <v-card-subtitle class="py-2 font-weight-bold">
                    Páginas ({{ paginasFacturaIa.length }}/{{ maximoPaginasFacturaIa }})
                  </v-card-subtitle>
                  <v-divider></v-divider>
                  <v-list dense>
                    <v-list-item v-for="(pagina, indice) in paginasFacturaIa" :key="pagina.id"
                      :class="{ 'indigo lighten-5': indice === indicePaginaFacturaIa }"
                      @click="seleccionarPaginaFacturaIa(indice)">
                      <v-list-item-avatar v-if="pagina.tipo === 'IMAGEN'" size="40" class="rounded-0">
                        <v-img :src="pagina.url" contain></v-img>
                      </v-list-item-avatar>
                      <v-list-item-avatar v-else size="40" color="grey lighten-3">
                        <v-icon small>fa-file-pdf</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="text-truncate">
                          {{ indice + 1 }}. {{ pagina.nombre }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ formatearTamanoArchivoIa(pagina.tamano) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action class="flex-row">
                        <v-btn icon small :disabled="analizandoFacturaIa || indice === 0"
                          aria-label="Subir página"
                          @click.stop="moverPaginaFacturaIa(indice, -1)">
                          <v-icon small>fa-arrow-up</v-icon>
                        </v-btn>
                        <v-btn icon small
                          :disabled="analizandoFacturaIa || indice === paginasFacturaIa.length - 1"
                          aria-label="Bajar página"
                          @click.stop="moverPaginaFacturaIa(indice, 1)">
                          <v-icon small>fa-arrow-down</v-icon>
                        </v-btn>
                        <v-btn icon small :disabled="analizandoFacturaIa" color="error"
                          aria-label="Quitar página"
                          @click.stop="quitarPaginaFacturaIa(indice)">
                          <v-icon small>fa-trash</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
                <v-alert v-if="preparandoCatalogoIa" type="info" dense outlined class="mb-2">
                  Preparando catálogo… ({{ pendientesCatalogoIa }} pendientes). Puede seguir trabajando.
                </v-alert>
                <v-alert v-if="mensajeAnalisisIa || detalleMensajesCargaFacturaIa.length"
                  :type="tipoMensajeAnalisisIa" dense outlined>
                  <div v-if="mensajeAnalisisIa" class="font-weight-bold mb-1">{{ mensajeAnalisisIa }}</div>
                  <div v-for="(detalle, indiceDetalle) in detalleMensajesCargaFacturaIa"
                    :key="'msg-carga-ia-' + indiceDetalle">
                    • {{ detalle }}
                  </div>
                </v-alert>
                <v-alert v-for="grupo in gruposValidacionFacturaIa" :key="grupo.categoria"
                  :type="grupo.tipo" dense outlined>
                  <div class="font-weight-bold mb-1">{{ grupo.titulo }}</div>
                  <div v-for="(mensaje, indice) in grupo.mensajes" :key="grupo.categoria + '-' + indice">
                    • {{ mensaje }}
                  </div>
                </v-alert>
                <v-checkbox v-if="resultadoFacturaIa" v-model="confirmacionRevisionIa"
                  label="He revisado y corregido los datos cargados por la IA"></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="analizandoFacturaIa || validandoCalidadFacturaIa" @click="dialogAnalisisIa = false">Cancelar</v-btn>
          <v-btn v-if="!resultadoFacturaIa" color="indigo" dark
            :loading="analizandoFacturaIa || validandoCalidadFacturaIa"
            :disabled="!paginasFacturaIa.length || validandoCalidadFacturaIa" @click="analizarFacturaIa">
            Analizar
          </v-btn>
          <v-btn v-else color="success" :disabled="!confirmacionRevisionIa" @click="confirmarRevisionFacturaIa">
            Confirmar revisión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <table style="position: absolute" width="100%" :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8">
      <tr max-height="48px" height="48px">
        <ContenidoBase :titulo="modoIa ? 'Registro de Facturas IA' : 'Registro Facturas de Proveedores'"
          :descripcion="modoIa ? 'Analice y revise la factura antes de guardarla.' : 'Esta función permite realizar Facturas a proveedores.'"
          :EstadoBtn="EstadoBtn" :mostrarAnalisisIa="modoIa"
          @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="NotifMessageNuevo" @MethodGuardar="save"
          @MethodAnalizarIa="dialogAnalisisIa = true"
          @MethodEliminar="NotifMessage" @MethodAnular="NotifMessage" @MethodImprimir="imprimirList"
          @MethodVeercuenta="vercuenta" @MethodGuardarTemporal="Saavetem" @MethodRestaurarTemporal="Restaurartem"
          @MethodImportarDato="importarDato" @MethodReimprimirEtiqueta="MethodReimprimirEtiqueta" />
      </tr>
      <tr>
        
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
          
             <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->

                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver"><i style="font-size: 25px"
                        class="fa fa-eye"> </i>
                      ver</v-btn>
                    <v-btn color="teal darken-2" dark text small @click.prevent="
                      (dialogFiltros = true),
                      (ObjTemTbDinam = JSON.parse(
                        JSON.stringify(Modallfiltro)
                      ))
                      ">
                      <i style="font-size: 25px" class="fa fa-search"> </i>
                      Filtrar
                    </v-btn>

                    <v-switch class="mt-0" color="teal" label="" v-model="searchByCodigo" dense
                      @change="CargarListTb">
                      <template v-slot:label>
                        <strong v-if="searchByCodigo"  style="color:#000000; font-size:12px;"> 
                          Codigo
                        </strong>
                        <strong v-else  style="color:#000000; font-size:12px;"> 
                          Referencia
                        </strong>
                      </template>
                    </v-switch>
                  </v-btn-toggle>
                </center>

                <!-- <v-navigation-drawer >  -->

                <BarraDinamicaLimitePlus :PropsNombre="'Facturas Proveedores'" PropsSearch
                  :PropsSeachNombre="'Búsqueda por #Factura'" :TbPaginator="TbPaginator" :TbTotalItem="TbTotalItem"
                  :PropsList="ListItems" @CargarPaginacion="CargarPaginacion" @EmitDAta="datostabla" :headers="[
                    { text: 'Código', value: 'facturasProveedoresPK.codigo' },
                    /* { text: 'Nombre', value: 'nombre' },
                     { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]" :ContListSlot="[
                    { Text: 'Código', NomValue: 'facturasProveedoresPK', Nv2: 'codigo', Ctsl: 2, Type: 0, State: true, },
                    { Text: '#Factura', NomValue: 'referencia', Ctsl: 1, Type: 0, State: true, },
                    { Text: 'proveedor', NomValue: 'proveedor', Nv2: 'nombre', Ctsl: 2, Type: 0, State: true, },
                    { Text: 'fecha', NomValue: 'nuevaFecha', Ctsl: 1, Type: 1, State: true, },
                    { Text: 'Valor $', NomValue: 'total', Ctsl: 1, Type: 2, State: true, },
                    { Text: 'Estado', NomValue: 'activada', Ctsl: 1, Type: 0.2, State: true, },
                    { Text: 'Fecha Creación', NomValue: 'nuevaFechaCreacion', Ctsl: 1, Type: 1, State: true, },
                    { Text: 'Usuario Creacion ', NomValue: 'usuarioCreacion', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Fecha Anulación', NomValue: 'fechaAnulacionNuevo', Ctsl: 1, Type: 1, State: true, },
                    { Text: 'Usuario Anulación ', NomValue: 'usuarioAnulacion', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Comentario', NomValue: 'comentario', Ctsl: 1, Type: 0, State: true },

                  ]" />

                <!-- </v-navigation-drawer> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">
              <v-card color="grey lighten-3">
                <div class="px-2">
                  <v-form ref="formFactPro" v-model="valid" lazy-validation>
                    <input type="number" v-model="FacturaProveedor.codigo" style="display: none" />
                    <v-row>
                      <v-col cols="12" md="4" sm="4">
                        <!-------------------------------------------------- proveedor -->

                        <v-combobox id="formdisabledInput" :disabled="InputDisabled" autocomplete="off" dense outlined
                          label="* Proveedor:" :items="Rproveedor" item-text="nombre" placeholder=" "
                          style="font-size: 13px" :rules="[$rules.required]" v-model="FacturaProveedor.proveedor"
                          @blur="SelctCbProveedor" @focus="cargarProveedor" @keyup="CbFilProveedor"
                          @change="BuscaOrdenCompra" v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-user-circle"></i>
                          </template>
                        </v-combobox>

                        <v-row style="margin-top: -10px">
                          <!-- sub columna 1 -->
                          <v-col cols="12" md="7" sm="7">
                            <!----------------------------------------------  Fecha entrada -->
                            <v-text-field dense outlined type="date" label="Fecha " @blur="verificarYearfecha()"
                              :rules="[$rules.required]" v-model="FacturaProveedor.fecha" placeholder=" "
                              style="font-size: 13px">
                              <template v-slot:prepend>
                                <i style="font-size: 20px" class="fa fa-calendar"></i>
                              </template>
                            </v-text-field>
                          </v-col>
                          <!-- fn sub columna 1 -->

                          <!-- sub columna 2 -->
                          <v-col cols="12" md="5" sm="5">
                            <!-- Plazo -------------------------------------------------:disabled="InputDisabled" -->
                            <AutoNumeric id="formdisabledInput" label="Plazo:" dense outlined autocomplete="off"
                              v-model.number="FacturaProveedor.diascredito">
                              <template v-slot:prepend>
                                <i style="font-size: 20px" class="fa fa-clock-o"></i>
                              </template>
                            </AutoNumeric>
                          </v-col>
                          <!-- fn sub columna 2 -->
                        </v-row>

                        <!-------------------------------------------------- Comentario -->
                        <v-textarea id="formdisabledInput" :disabled="InputDisabled" style="margin-top: -14px"
                          autocomplete="off" label="Comentario" dense outlined v-model="FacturaProveedor.comentario"
                          rows="1" hide-details>
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-commenting"></i>
                          </template>
                        </v-textarea>
                      </v-col>

                      <!-- columna 1 ------------------------------>
                      <v-col cols="12" md="2" sm="2">
                        <!------------------------------------------ Documentos -->
                        <v-combobox id="formdisabledInput" :disabled="InputDisabled" autocomplete="off" dense outlined
                          label="* Documentos:" :items="RDocumento" item-text="descripcion" :rules="[rules.required]"
                          placeholder=" " style="font-size: 13px" v-model="FacturaProveedor.documentoproveedor"
                          @blur="SelctCbDocumento" v-on:blur="getCrearCont" @focus="cargarDocumento">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-book"></i>
                          </template>
                        </v-combobox>

                        <!---------------------------------------------- moneda-->
                        <v-combobox id="formdisabledInput" :disabled="InputDisabled" autocomplete="off" dense outlined
                          label="Moneda" :items="Rmoneda" item-text="nombrecorto" :rules="[rules.required]"
                          v-model="FacturaProveedor.moneda" @blur="SelctCbMoneda" @focus="cargarMoneda"
                          v-on:blur="calcularDetalleMoneda(ListProd)">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-usd"></i>
                          </template>
                        </v-combobox>

                        <!-- Tipo de gasto -----------------------:disabled="InputDisabled"---------------------------->
                        <v-combobox id="formdisabledInput" v-model="tipogasto" label="Tipo de Gasto:" required outlined
                          dense autocomplete="off" :items="RTipoGasto" item-text="descripcion" @focus="CargarRTipopago"
                          @blur="SelctCbTipoGasto" placeholder=" " style="font-size: 13px" hide-details>
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-tag"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 1 ------------------------------>

                      <!-- columna 2 ------------------------------>
                      <v-col cols="12" md="2" sm="2">
                        <!-- Factura No --------------------------------------------------->
                        <v-text-field label="* Factura No:" dense outlined :rules="[rules.required]"
                          v-model="FacturaProveedor.referencia" @blur="repetidosNoFactura" v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-slack"></i>
                          </template>
                        </v-text-field>

                        <AutoNumericNuevoWithOptions :options="{ decimalPlaces: '4' }" id="formdisabledInput"
                          :disabled="InputDisabled" label="tasa:" dense outlined autocomplete="off"
                          v-model.number="FacturaProveedor.tasa">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-usd"></i>
                          </template>
                        </AutoNumericNuevoWithOptions>

                        <!-- ----------------------------- descuento descuentoIndividual-->
                        <AutoNumeric id="formdisabledInput" :disabled="InputDisabled" label="Desc Individual:" dense
                          outlined autocomplete="off" v-model.number="FacturaProveedor.descuentoIdividual"
                          @blur="calcularDescuentoIndividual" hide-details>
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-usd"></i>
                          </template>
                        </AutoNumeric>
                      </v-col>
                      <!-- columna 2 ------------------------------>

                      <!-- columna 3 ------------------------------>
                      <v-col cols="12" md="2" sm="2">
                        <!-- Código fijo NCF --------------------------------------------------->
                        <v-text-field label=" Código fijo NCF :" dense outlined placeholder=" " style="font-size: 13px"
                          @blur="repetidosNcf" v-on:blur="BlurCambioMayuscula" v-model="datosNCF.codigoFijo" :rules="[rules.ncfLimit()]">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-list-alt"></i>
                          </template>
                        </v-text-field>

                        <!------------------------------------------------ Imp. Selectivo -->
                        <AutoNumeric id="formdisabledInput" :disabled="InputDisabled" label="Imp. Selectivo:" dense
                          outlined autocomplete="off" v-model.number="FacturaProveedor.selectivo">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-usd"></i>
                          </template>
                        </AutoNumeric>

                        <!------------------------------------------------ ITBIS incluido -->

                        <!-- no-gutters -->
                        <!-- <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px solid #000000;" ></v-col> -->
                        <v-row>
                          <v-col cols="6" md="6" sm="6" class="pa-0 ma-0 py-0 my-0">
                            <v-switch id="formdisabledInput" :disabled="InputDisabled" class="mt-0"
                              v-model="FacturaProveedor.itbisincluido" label="ITBIS incluido" color="success"
                              hide-detail @change="calcularImpuesto" hide-details>
                              <template v-slot:label>
                                <strong style="color: #000000; font-size: 13px">ITBIS incluido</strong>
                              </template>
                            </v-switch>
                          </v-col>

                          <v-col cols="6" md="6" sm="6" class="pa-0 ma-0 py-0 my-0">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn id="boton-mini" color="red accent-2" v-on="on" dark small
                                  @click.prevent="openDialogCargerImagen">
                                  <i style="font-size: 18px" class="fa fa-file-image-o">
                                  </i>
                                  Cargar IMG
                                </v-btn>
                              </template>
                              <span>Cargar imagen </span>
                            </v-tooltip>
                          </v-col>

                        </v-row>

                      </v-col>
                      <!-- columna 3 ------------------------------>

                      <!-- columna 4 ------------------------------>
                      <v-col cols="12" md="2" sm="2">
                        <!-- Secuencia NCF --------------------------------------------------->
                        <v-text-field label="Secuencia NCF:" ref="secuenciaRef" dense outlined v-model="datosNCF.secuencia" placeholder=" "
                          style="font-size: 13px" @blur="repetidosNcf" v-on:blur="completarDigitos" :rules="[rules.ncfLimit()]">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-barcode"></i>
                          </template>
                        </v-text-field>

                        <!-------------------------------------------------- Valor -->
                        <AutoNumericNuevoWithOptions :options="{ decimalPlaces: '4' }" id="formdisabledInput"
                          :disabled="InputDisabled" label="* Valor:" dense outlined autocomplete="off"
                          v-model.number="FacturaProveedor.total" :rules="[rules.required]" v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-usd"></i>
                          </template>
                        </AutoNumericNuevoWithOptions>

                        <v-tooltip top v-if="ProveedorOrdenCompra.length > 0">
                          <template v-slot:activator="{ on }">
                            <v-btn :disabled="InputDisabled" id="boton-mini" color="blue lighten-3" v-on="on" dark small
                              @click.prevent="OpenProveedorOrdenCompra">
                              <i style="font-size: 18px" class="fa fa-cart-arrow-down">
                              </i>
                              Ordenes de compra
                            </v-btn>
                          </template>
                          <span>Ordenes de compra </span>
                        </v-tooltip>
                      </v-col>
                      <!-- columna 4 ------------------------------>

                      <!-- columna 5  ------------------------------>
                      <v-col cols="12" md="4" sm="4">
                        <!-------------------------------------------------- Almacén -->
                        <v-combobox autocomplete="off" dense outlined label="* Almacén:" :items="Ralmacen"
                          item-text="descripcion" v-model="almacen" @blur="SelctCbAlmacenTb" @focus="CargarRalmacen"
                          @change="ChangeAlmacen">
                          <template v-slot:prepend>
                            <v-img height="20px" width="20px" src="../../assets/warehouse.png"></v-img>
                            <!-- <i style="font-size: 20px;" class="fa fa-user-circle"></i> -->
                          </template>
                        </v-combobox>
                      </v-col>

                      <!-- columna 5  ------------------------------>

                    </v-row>
                  </v-form>
                </div>
                <!-- unidad por si acaso :   :PropsUnidadminima="false" -->

                <v-col cols="12" md="12" sm="12" style="margin-top: -35px">

                  <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0" 
                      v-if="FacturaProveedor.facturasProveedoresPK.codigo>0 && FacturaProveedor.hasOwnProperty('facturasProveedoresDetalleList') && FacturaProveedor.facturasProveedoresDetalleList.length==0">
                          <span>
                          <b>Nota:</b><span style="color: #C62828;"> Este es un Registro Facturas de Manuales. </span>
                        </span>
                      </v-col>

                  <TablaProductoCxp ref="detalle" :ListProd="ListProd" :PropsFacturaProveedor="true"
                    :PropsDecimalPlaces="4" :PropsInputDisabled="InputDisabled" :EntradaAlmacen="almacen"
                    :ProsActuAlmacen="ActualizaAlmacen" @DataTotalList="DDataTotalList"
                    @DataActAlmacen="ActualizaAlmacen = false"
                    :PropsUnidadminima="this.$store.getters.GetConfiguracionGeneral.configCxp.unidadminima"
                    :showCrearProducto="true"
                    :omitirFilaVaciaAutomatica="omitirFilaVaciaAutomatica" />
                </v-col>
              </v-card>
            </div>
          </v-app>
        </td>
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }"></div>
        </td>
      </tr>
    </table>
    <!-- Modales ----------------------------------------------------------------------------------------------->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent transition="dialog-bottom-transition" fullscreen
      hide-overlay>
      <v-card>
        <v-toolbar dense flat color="#BDBDBD">
          <i style="font-size: 20px" class="fa fa-file-pdf-o"> </i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" dark small color="deep-purple accent-2" @click.prevent="OpendialogimprimirListFilt()">
                <i style="font-size: 25px" class="fa fa-print"> </i>
                Listado
              </v-btn>
            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>
          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i style="font-size: 20px; color: #dd4b39" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="Modallfiltro.factura" @keyup.enter="CargarListTb" label="Búsqueda por #Factura"
                single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px" class="fa fa-search"></i>
                </template>
                <template v-slot:append-outer>
                  <v-btn color="teal darken-2" dark small @click.prevent="
                    (dialogFiltros = true),
                    (ObjTemTbDinam = JSON.parse(
                      JSON.stringify(Modallfiltro)
                    ))
                    ">
                    <i style="font-size: 25px" class="fa fa-search"> </i>
                    Filtros
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table class="TbSize13" :headers="[
              {
                text: 'Código',
                value: 'facturasProveedoresPK.codigo',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: '#Factura',
                value: 'referencia',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Fecha',
                value: 'nuevaFecha',
                width: 120,
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Proveedor',
                value: 'proveedor.nombre',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Valor',
                value: 'valor',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Documento',
                value: 'documentoproveedor.descripcion',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Moneda',
                value: 'moneda.descripcion',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Comentario',
                value: 'comentario',
                sortable: false,
                class: ['no-gutters black--text'],
              },
              {
                text: 'Estado',
                value: 'activada',
                sortable: false,
                class: ['no-gutters black--text'],
              },
            ]" dense @pagination="cargarPaginacionAll" :items-per-page="TbPaginator.itemsPerPage"
              :page="TbPaginator.page" :pageCount="TbPaginator.pageCount" :items="ListItems"
              :search="Modallfiltro.factura" @click:row="datostabla" :server-items-length="TbTotalItem">
              <template v-slot:item.valor="props">
                <span>{{ currencyFormatter(props.item.valor) }}</span>
              </template>

              <template v-slot:item.nuevaFecha="props">
                <span>{{ FormatoFecha(props.item.nuevaFecha) }}</span>
              </template>

              <template v-slot:item.activada="props">
                <span v-if="props.item.activada == true">Activo</span>
                <span v-if="props.item.activada == false">Anulado</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data-->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog label="myAlert" v-model="notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'SaveContFactPro'" @click.prevent="saveReg(), (notif.estado = !notif.estado)"
            small>
            <i style="font-size: 20px" class="fa fa-check"></i> Si
          </v-btn>
          <v-btn v-if="notif.Exec =='NuevoFactPro'" @click.prevent="newwnuevo(), (notif.estado= !notif.estado)" small>
          <i style="font-size: 20px" class="fa fa-check"></i> Si
          </v-btn>
          <v-btn v-if="notif.Exec == 'AnularFactPro'" @click.prevent="anular(), (notif.estado = !notif.estado)" small>
            <i style="font-size: 20px" class="fa fa-check"></i> Si
          </v-btn>
          <v-btn @click.prevent="notif.estado = !notif.estado" small>
            <i style="font-size: 20px" class="fa fa-ban"></i> No
          </v-btn>

         
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->
    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar v-model="snackbarCatalogoIa" color="info" :timeout="-1" top multi-line>
      Preparando catálogo… {{ pendientesCatalogoIa > 0 ? "(" + pendientesCatalogoIa + " pendientes)" : "" }}
      Puede analizar y revisar mientras termina.
      <v-btn dark text @click="cerrarMensajeCatalogoIa">Cerrar</v-btn>
    </v-snackbar>
    <v-snackbar v-model="aalert.estado" :color="aalert.color" id="alerMov" :vertical="true" :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->
    <!-- ------------------------------------------------------ Modal Filtro -->
    <v-dialog transition="fab-transition" label="Modal agregar factura" v-model="dialogFiltros" persistent
      max-width="90%" max-height="80%">
      <v-card>
        <v-toolbar flat color="indigo" dense>
          <i style="font-size: 20px" class=""> </i>
          <v-toolbar-title style="color: white" class="font-weight-light">
            <b>FILTROS</b>
          </v-toolbar-title>
          <i style="font-size: 20px" class=""> </i>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="
            (dialogFiltros = false),
            (Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam)))
            ">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <!-------------------------------------------------- Nombre  -->

              <v-combobox autocomplete="off" dense outlined label="Proveedor:" style="font-size: 13px"
                :items="Rproveedor" item-text="nombre" v-model="Modallfiltro.proveedores"
                @blur="SelctCbProveedoresFiltro" @focus="cargarProveedor" @keyup="CbFilProveedor">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-user-circle"></i>
                </template>
              </v-combobox>
            </v-col>

            <v-col cols="12" md="6" sm="6">
              <!---------------------------------------------- documento -->
              <v-combobox autocomplete="off" dense outlined label="Documentos:" :items="RDocumento"
                item-text="descripcion" :rules="[$rules.required]" v-model="Modallfiltro.documento"
                @blur="SelctCbDocumentoFiltro" @focus="cargarDocumento">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-book"></i>
                </template>
              </v-combobox>
            </v-col>

            <v-col cols="12" md="6" sm="6">
              <v-text-field label="* Factura No:" dense outlined :rules="[$rules.required]"
                v-model="Modallfiltro.factura">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-slack"></i>
                </template>
              </v-text-field>
            </v-col>

            <!-- -----------------------------  columna-1 -->
            <v-col cols="12" md="6" sm="6">
              <!----------------------------------------------  Desde -->
              <v-text-field dense outlined type="date" label="Desde*" v-model="Modallfiltro.Desde">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-calendar"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-1 -->
            <!-- -----------------------------  columna-2 -->
            <v-col cols="12" md="6" sm="6">
              <!-------------------------------------------------- Hasta -->
              <v-text-field dense outlined type="date" label="Hasta*" v-model="Modallfiltro.Hasta">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-calendar"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-2 -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle rounded class="" dense>
            <v-btn color="#90A4AE" @click.prevent="Limpiarfiltro">
              <i style="font-size: 28px" class="fa fa-file-o"> </i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" @click.prevent="BuscarFiltros">
              <i style="font-size: 28px" class="fa fa-search"> </i>
              Buscar
            </v-btn>
          </v-btn-toggle>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ fn Modal filtro -->

    <!-- ------------------------------------------------------ Modal- Reportes-->
    <v-dialog transition="fab-transition" label="Modal agregar cuenta" v-model="dialogimprimirListFilt" persistent
      max-width="80%" max-height="50%">
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">
        <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000">
          <v-avatar tile size="45">
            <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte" />
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px">
            <b>REPORTE LISTADO REGISTRO FACTURAS DE PROVEEDORES</b>
          </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <hr />

        <v-container style="border: 1px solid #000000">
          <v-form ref="formImpr" @submit.prevent="" v-model="valid" lazy-validation>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" md="12" sm="12">
                <!---------------------------------------------- documento -->
                <v-combobox autocomplete="off" dense outlined label="Documentos:" :items="RDocumento"
                  item-text="descripcion" :rules="[$rules.required]" v-model="datosImprecionAll.documentos"
                  @blur="SelctCbReportDocumento" @focus="cargarDocumento">
                  <template v-slot:prepend>
                    <i style="font-size: 20px" class="fa fa-book"></i>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-text-field dense outlined type="date" label="Desde*" v-model="datosImprecionAll.desde"
                  :rules="[$rules.required]" @blur="ReportBlurDesde">
                  <template v-slot:prepend>
                    <i style="font-size: 20px" class="fa fa-calendar"></i>
                  </template>
                </v-text-field>

                <v-checkbox class="mt-0" color="teal" label="" v-model="datosImprecionAll.FecRegi" width="50">
                  <template v-slot:label>
                    <strong v-if="datosImprecionAll.FecRegi == true" style="color: #000000; font-size: 13px">Fecha de
                      Registro: Si</strong>
                    <strong v-if="datosImprecionAll.FecRegi == false" style="color: #000000; font-size: 13px">Fecha de
                      Registro: No</strong>
                  </template>
                </v-checkbox>
                  <v-checkbox class="mt-0" color="teal" label="" v-model="datosImprecionAll.soloNcf" width="50">
                  <template v-slot:label>
                    <strong v-if="datosImprecionAll.soloNcf == true" style="color: #000000; font-size: 13px">Solo Facturas Con Ncf: Si</strong>
                    <strong v-if="datosImprecionAll.soloNcf == false" style="color: #000000; font-size: 13px">Solo Facturas Con Ncf:: No</strong>
                  </template>
                </v-checkbox>
              </v-col>

              <v-col cols="12" md="6" sm="6">
                <!-------------------------------------------------- Hasta -->
                <v-text-field dense outlined type="date" label="Hasta*" v-model="datosImprecionAll.hasta"
                  :rules="[$rules.required]" @blur="ReportBlurHasta">
                  <template v-slot:prepend>
                    <i style="font-size: 20px" class="fa fa-calendar"></i>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <hr />

        <ModalReporteFiltros ref="ModRepfil" @DataReporteBasico="DDataReporteBasico" :Datos="datosImprecionAll" />
      </v-card>
      <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal reportes -->

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog transition="fab-transition" label="Modal Reporte Basico" v-model="dialogimprimirList" persistent
      max-width="80%" max-height="50%">
      <ModalReporteBasico @DataReporteBasico="DDataReporteBasico" :Datos="datosImprecion" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->

    <!-- ------------------------------------------------------ Modal- agregar cuenta-->
    <v-dialog transition="fab-transition" label="Modal agregar cuenta" v-model="acti_Modal_cuenta" persistent
      max-width="80%" max-height="50%">
      <CuentasContables @CuentasContables="CCuentasContables" :RLisCuenta="RLisCuenta" :objeTem="objeTem"
        :Total="TotalCuenta" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal agregar cuenta-->

    <!-- ------------------------------------------------------ Modal Provedor orden de compra -->
    <v-dialog transition="fab-transition" label="Modal agregar factura" v-model="dialogProveedorOrdenCompra" persistent
      max-width="90%" max-height="80%">
      <v-card>
        <v-toolbar flat color="indigo" dense>
          <i style="font-size: 20px" class=""> </i>
          <v-toolbar-title style="color: white" class="font-weight-light">
            <b>Ordenes de Compra</b>
          </v-toolbar-title>
          <i style="font-size: 20px" class=""> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="dialogProveedorOrdenCompra = false">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-data-table class="RowSelectColor" :single-select="true" item-key="indx" :show-select="true"
                v-model="ProveedorOrdenCompraSelected" @item-selected="ProveedorOrdenCompraObtenerDatoSelect"
                @click:row="ProveedorOrdenCompraDatostabla" :headers="[
                  {
                    text: 'CODIGO',
                    sortable: false,
                    value: 'codigo',
                    width: 'auto',
                  },
                  {
                    text: 'FECHA',
                    sortable: false,
                    value: 'fecha',
                    width: 120,
                  },
                  {
                    text: 'VALOR',
                    sortable: false,
                    value: 'valor',
                    width: 'auto',
                    width: 'auto',
                  },
                  {
                    text: 'CONCEPTO',
                    sortable: false,
                    value: 'comentario',
                    width: 200,
                  },
                ]" dense :items="ProveedorOrdenCompra" :items-per-page="-1">
                <template v-slot:item.fecha="props">
                  <span style="font-size: 13px; display: none">{{
                    (props.item.indx = ProveedorOrdenCompra.indexOf(props.item))
                    }}</span>
                  <span style="font-size: 13px">{{
                    FormatoFecha(props.item.fecha)
                    }}</span>
                </template>

                <template v-slot:item.codigo="props">
                  <span style="font-size: 13px">{{ props.item.codigo }} </span>
                </template>

                <template v-slot:item.valor="props">
                  <span style="font-size: 13px">{{
                    currencyFormatter(props.item.valor)
                    }}</span>
                </template>

                <template v-slot:item.concepto="props">
                  <span style="font-size: 13px">{{ props.item.concepto }}
                  </span>
                </template>
              </v-data-table>
            </v-col>

            <!-- ----------------------------- fn columna-2 -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ fn Modal Provedor orden de compra -->

    <!-- ------------------------------------------------------ Modal- Restaurar temporal-->
    <v-dialog transition="fab-transition" label="Modal Restaurar temporal" v-model="dialogRestaurarTemporal" persistent
      max-width="90%" max-height="80%">
      <v-card>
        <v-toolbar flat color="indigo" dense>
          <i style="font-size: 20px" class=""> </i>
          <v-toolbar-title style="color: white" class="font-weight-light">
            <b>RESTAURAR TEMPORAL</b>
          </v-toolbar-title>
          <i style="font-size: 20px" class=""> </i>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="dialogRestaurarTemporal = false">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <!-- @click:row="RestaurarTempDatostabla"  -->
              <v-data-table class="RowSelectColor" item-key="indx" :headers="[
                { text: 'CODIGO', sortable: false, value: 'codigo', width: 'auto', class: ['no-gutters black--texte'], },
                { text: 'PROVEEDOR', sortable: false, value: 'proveedor.nombre', width: 'auto', class: ['no-gutters black--texte'], },
                { text: 'FECHA', sortable: false, value: 'nuevaFecha', width: 120, class: ['no-gutters black--texte'], },
                { text: 'ACCIÓN', value: 'action', width: '130', sortable: true }
              ]" dense :items="RestaurarTempList" :items-per-page="-1">
                <template v-slot:item.nuevaFecha="props">
                  <span style="font-size: 13px; display: none">{{ (props.item.indx =
                    RestaurarTempList.indexOf(props.item)) }}</span>
                  <span style="font-size: 13px">{{
                    FormatoFecha(props.item.nuevaFecha)
                    }}</span>
                </template>

                <template v-slot:item.codigo="props">
                  <span style="font-size: 13px">{{ props.item.documentoproveedor.nombrecorto }}-{{
                    props.item.facturasProveedorestempPK.codigo
                    }}
                  </span>
                </template>

                <template v-slot:item.proveedor.nombre="props">
                  <span style="font-size: 13px">{{
                    props.item.proveedor.nombre
                    }}</span>
                </template>


                <template #item.action="{ item }">
                    <v-btn fab @click.prevent="RestaurarTempDatostabla(item)" x-small color="yellow accent-4"><i
                        style="font-size: 20px;" class="fa fa-eye"></i></v-btn>

                    <v-btn fab @click.prevent="ImprimirRestaurarFact(item)" x-small color="blue"><i
                        style="font-size: 20px;" class="fa fa-print"></i></v-btn>

                    <v-btn fab @click.prevent="anularFacturaTemporal(item)" x-small color="red"><i
                        style="font-size: 20px;" class="fa fa-trash"></i></v-btn>
                </template>


              </v-data-table>
            </v-col>

            <!-- ----------------------------- fn columna-2 -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Restaurar temporal-->

    <!-- ------------------------------------------------------ Seleccionar impresora -->
    <v-dialog transition="fab-transition" label="Modal agregar factura" v-model="dialogImprimirEtiqueta" persistent
      max-width="90%" max-height="80%">
      <v-card>
        <v-toolbar flat color="indigo" dense>
          <i style="font-size: 20px" class=""> </i>
          <v-toolbar-title style="color: white" class="font-weight-light">
            <b>SELECCIÓN DE IMPRESORA </b>
          </v-toolbar-title>
          <i style="font-size: 20px" class=""> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click.prevent="dialogImprimirEtiqueta = false,listaProducImprir=[]">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br />

          <v-row>
            <!-- -----------------------------  columna-1 -->
            <v-col cols="12" md="12" sm="12">
              <v-combobox autocomplete="off" dense outlined label="Impresora de código de barra:" @focus="buscarFormato"
                :items="RlistFormato" item-text="descripcion" v-model="ImprirEtiqueta.ImpesoraBarra">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-barcode"></i>
                </template>
              </v-combobox>

              <v-combobox v-if="false" autocomplete="off" dense outlined label="Seleccione Terminal:"
                v-model="ImprirEtiqueta.seleCtTerminar">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-trademark"></i>
                </template>
              </v-combobox>

              <v-combobox autocomplete="off" dense outlined label="Seleccione Impresora:" @focus="cargarImpresoras"
                :items="RlistImpresora" item-text="nombre" v-model="ImprirEtiqueta.selectImpresora">
                <template v-slot:prepend>
                  <i style="font-size: 20px" class="fa fa-print"></i>
                </template>
              </v-combobox>

              <!-- DETALLE  IMPRESION FACT.PROVEE -->
               <v-col v-if="$store.getters.GetConfiguracionGeneral.configCxp.hasOwnProperty('cambiarCantidadEtiqueta') && $store.getters.GetConfiguracionGeneral.configCxp.cambiarCantidadEtiqueta  == true" 
               class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
               <v-card color="grey lighten-3" > 
                  <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <span :class="`pl-2 d-flex justify-start black--text`"><b>DETALLE PRODUCTO FACT.PROVEEDOR</b></span>
                  </v-col>

                <v-lazy  v-model="isActive" :options="{  threshold: .5 }" min-height="500"  transition="fade-transition">

                    <div class="px-2 pt-1 overflow-x-auto" style="border: 1px solid #000000; max-height:500px; height:500px; " >
                      <v-form v-model="valid" ref="formTabDetImprFactPro" lazy-validation> 

                                   <v-data-table class="elevation-1"  id="TbBord" dense
                                        :headers="[
                                       { text: 'CÓDIGO', value: 'codigoid',width:130,sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'PRODUCTO', value: 'producto',width:'auto',sortable:false, class: ['no-gutters black--text']},
                                       { text: 'CANTIDAD', value: 'cantidad',width:'auto',sortable:false, class: ['no-gutters black--text'] }, 
                                        ]"
                                        :items="listaProducImprir" :items-per-page="-1" item-key="indx">

                                      <template v-slot:item.codigoid="props">
                                        <span style="font-size:13px; display:none;">{{props.item.indx = listaProducImprir.indexOf(props.item)}}</span>

                                        <v-text-field :value="GetCodigoProdUni(props.item)" id="formdisabledInput"
                                          autocomplete="off"  class="pt-0 mt-0 fontSize12" disabled
                                           dense hide-details label="" single-line  >
                                        </v-text-field>

                                      </template>
                                      
                                      <template v-slot:item.producto="props">
                                         <v-text-field v-if="props.item.productos!=null && props.item.unidades!=null" :value="`${props.item.productos.descripcion.trim()} ${props.item.unidades.descripcion.trim()}`" 
                                         id="formdisabledInput" autocomplete="off"  class="pt-0 mt-0 fontSize12" disabled
                                           dense hide-details label="" single-line  >
                                        </v-text-field>
                                      </template>

                                
                                    <template v-slot:item.cantidad="props">

                                      <AutoNumeric id="formdisabledInput" label="" dense single-line  autocomplete="off"
                                       class="pt-0 mt-0 fontSize12"  v-model.number="props.item.cantidad" hide-details>
                                     </AutoNumeric>

                                    </template>

                                </v-data-table>
                             </v-form>

                    </div>
              </v-lazy>

                  </v-card>
               </v-col>
              <!-- FN DETALLE  IMPRESION FACT.PROVEE -->



            </v-col>
            <!-- ----------------------------- fn columna-1 -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn-toggle rounded class="" dense>
            <v-btn color="blue" @click.prevent="ImprimirEtiqueta">
              <i style="font-size: 28px" class="fa fa-print"> </i>
              Imprimir
            </v-btn>
          </v-btn-toggle>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-------------------------------------------------------- fn Seleccionar impresora -->
    <!-- hide-overlay max-width="95%" max-height="85%" -->
    <!-- ------------------------------------------------------ Modal- cargar imagen-->
    <v-dialog transition="dialog-bottom-transition" label="Modal cargar imagen" v-model="dialogCargerImagen" persistent
      fullscreen>
      <v-card class="mx-auto" style="border: 1px solid #000000;">
        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
          <!--------------------- Creacion cargar imagen------------------------------->
          <div>

            <!-- <div style="max-height:345px;" class="overflow-x-auto">
</div> -->

            <v-toolbar dark color="indigo" dense>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <v-toolbar-title v-on="on"> <i style="font-size: 20px;" class="fa fa-info-circle"> </i> Cargar Imagen
                  </v-toolbar-title>

                </template>
                <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> <span> Cargar Imagen: </span> Cargar
                  Imagen</i>

              </v-tooltip>

              <v-spacer></v-spacer>

              <v-card-actions>
                <v-btn-toggle></v-btn-toggle>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-btn color="grey darken-4" fab small @click="cerrarCargarImagen">
                      <i style="font-size: 20px; color:white;" class="fa fa-close"></i>
                    </v-btn>
                  </template>
                  <span>CANCELAR: Retornar </span>
                </v-tooltip>



              </v-card-actions>
            </v-toolbar>
            <!-- <v-card> -->
            <!-- columna Importar Datos -->
            <v-col cols="12" md="12" sm="12">

              <v-container>
                <v-card color="grey lighten-3">
                  <b :class="`d-flex justify-center`"> Cargar Imagen</b>
                  <v-form v-model="valid" ref="formInputFile" lazy-validation>
                    <!-- Row 1 Importar Datos     ------------------------------------------->

                    <v-row>

                      <v-col cols="12" md="12" sm="12">

                        <v-form ref="formInputFileImg" v-model="valid" lazy-validation>


                          <v-file-input dense outlined accept="image/png, image/jpeg, image/bmp" @change="ConvertirImg"
                            ref="files" id="imagenfooter" show-size counter small-chips v-model="objCargaImg.cargaImg"
                            multiple prepend-icon="mdi-camera" label="Cargar Imagen" :rules="[$rules.required]">
                            <template v-slot:append-outer>

                              <v-tooltip top>
                                <template v-slot:activator="{ on }">

                                  <v-btn @click.prevent="addArchivoList" v-on="on" color="green" fab x-small dark>
                                    <i style="font-size: 20px;" class="fa fa-plus-square"></i>
                                  </v-btn>

                                </template>
                                <span>Agregar a la lista</span>
                              </v-tooltip>
                              <!--  
                <v-tooltip top v-show="objCargaImg.codigo>0">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" fab @click.prevent="eliminarCargaImg()" x-small color="red darken-3">
                      <i style="font-size: 25px;" class="fa fa-trash-o"></i></v-btn>

                  </template>
                  <span>eliminar imagen</span>
                </v-tooltip>
                -->

                            </template>
                          </v-file-input>
                          <!-- max-height="auto" -->
                          <div v-if="loadercargarFoto == true">
                            <center>
                              <v-img v-if="objCargaImg.imgView != null && objCargaImg.imgView.trim().length > 0"
                                max-height="150" max-width="250" style="border: 2px solid #000000;"
                                :src="objCargaImg.imgView" :lazy-src="objCargaImg.imgView"></v-img>
                            </center>
                          </div>
                        </v-form>

                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0" v-for="(list, i) in listObjFoto"
                          :key="i">
                          <span style="font-size:13px; display:none;">{{ list.indx = listObjFoto.indexOf(list)
                            }}</span>
                          <!-- Col 1 -->
                          <v-col style="border: 1px dashed  #616161; background-color:#3F51B5;"
                            class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                            <v-row no-gutters>
                              <span style="font-size: 25px;" :class="`d-flex justify-start white--text`"><b>#{{ i + 1
                                  }}</b></span>
                              <!-- v-show="objCargaImg.codigo>0" -->
                              <v-spacer></v-spacer>
                              <div :class="`d-flex justify-end`">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" fab @click.prevent="eliminarCargaImg(list)" x-small
                                      color="red darken-3">
                                      <i :class="`white--text`" style="font-size: 25px;"
                                        class="fa fa-trash-o"></i></v-btn>

                                  </template>
                                  <span :class="`white--text`">eliminar imagen</span>
                                </v-tooltip>
                              </div>
                            </v-row>


                          </v-col>
                          <!-- fin Col 1 -->
                          <!-- Col 2 -->
                          <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                            <v-img v-if="list.imagen != null && list.imagen.trim().length > 0" max-height="auto"
                              style="border: 2px solid #000000;" :src="list.imagen" :lazy-src="list.imagen"></v-img>
                          </v-col>
                          <!-- fin Col 2 -->
                        </v-col>


                      </v-col>

                    </v-row>
                    <!-- Row 2 Importar Datos ------------------------------------------->
                  </v-form>
                </v-card>
              </v-container>
            </v-col>
            <!-- columna informacion Importar Datos -->

            <!-- </v-card> -->

          </div>
        </v-col>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- cargar imagen-->



    <!---------------------  Panel Menu Opcion Botones ------------------------------->
    <div style="max-height:300px;" class="overflow-x-auto" v-show="false">
      <!-- columna  ---------------------->
      <PvMenuOpcionBotones ref="RefPvMenuOpcionBotones" @DataRetornAccion="DataRetornMenuOpcBotonesPermisosPv"
        @DataRetornAccionPadre="DataRetornPadrePermisoPv" />
    </div>


  </div>

  <!-- fn Modales ----------------------------------------------------------------------------------------------->
</template>

<script>
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import AutoNumeric from "../../components/AutoNumericNuevo";
import AutoNumericNuevoWithOptions from "../../components/AutoNumericNuevoWithOptions.vue";
import { EventBus } from "../../event-bus";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import ModalReporteBasico from "../../components/ModalReporteBasico";
import TablaProductoCxp from "../../CuentaXPagar/UtilidadComponents/TablaProductoCxP";
import {
  currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  fechaNueva,
  getParamFecha,
  RedondeoBasico,
  getFechaZone,
  RedondeoValorCantRed
} from "@/js/Funciones.js";
import CuentasContables from "../../components/CuentasContables";
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus";
import PvMenuOpcionBotones from "@/PuntodeVenta/UtilidadComponents/PvMenuOpcionBotones.vue";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import { UMBRALES_CALIDAD_IMAGEN_FACTURA_IA } from "../utils/umbralesCalidadImagenFacturaIa";
import { analizarCalidadImagenFacturaIa } from "../utils/analizarCalidadImagenFacturaIa";

export default {
  props: {
    modoIa: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    AutoNumeric,
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros,
    ModalReporteBasico,
    TablaProductoCxp,
    CuentasContables,
    BarraDinamicaLimitePlus,
    AutoNumericNuevoWithOptions,
    PvMenuOpcionBotones,
    VuePdfEmbed
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("emitFacturaProveedor", this.datostabla);
    // EventBus.$on("cxpFacturaProveedorNew", this.new);
    // EventBus.$on("cxpFacturaProveedorSave", this.save);
    // EventBus.$on("cxpFacturaProveedorRemove", this.remove);
    // EventBus.$on("cxpFacturaProveedorAnular", this.anular);
    // EventBus.$on("cxpFacturaProveedorPrintList", this.imprimirList);
    // EventBus.$on("cxpFacturaProveedorVercuenta", this.vercuenta);
    // EventBus.$on("cxpFacturaProveedorSaavetem", this.Saavetem);
    // EventBus.$on("cxpFacturaProveedorRestaurartem", this.Restaurartem);
    EventBus.$on("onResize", this.onResize);
    this.loadInfo();
    if (this.modoIa)
      this.sincronizarEmbeddingsFacturaIaEnBackground();
    console.log(".")

    console.log('viendo-kmjyjy->',this.$store.getters.GetConfiguracionGeneral.configCxp.cambiarCantidadEtiqueta)

//this.actualzarinfo_factura_dgi(dt)
// console.log('Ver--cambiarCantidadEtiqueta>',
//   this.$store.getters.GetConfiguracionGeneral.configCxp.hasOwnProperty('cambiarCantidadEtiqueta') && this.configuraciones.configCxp.cambiarCantidadEtiqueta  == true
// )
  },
  beforeDestroy() {
    this.detenerMonitoreoCatalogoIa();
    this.liberarVistaPreviaFacturaIa();
  },

  created() {
    var json = {
      titulo: this.modoIa ? "Registro de Facturas IA" : "Registro Facturas de Proveedores",
      descripcion: this.modoIa
        ? "Analice una factura, revise los datos extraídos y guarde el registro."
        : "Esta función permite realizar Facturas a proveedores.",
      save: true,
      eliminar: true,
      anular: false,
      nuevo: true,
      imprimir: false,
      vercuenta: true,
      stemporal: true,
      rtemporal: true,

      accion: [
        "cxpFacturaProveedorNew",
        "cxpFacturaProveedorSave",
        "cxpFacturaProveedorRemove",
        "cxpFacturaProveedorAnular",
        "cxpFacturaProveedorPrintList",
        "cxpFacturaProveedorVercuenta",
        "cxpFacturaProveedorSaavetem",
        "cxpFacturaProveedorRestaurartem",
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
    this.cargarMoneda();
    this.findAlmacenPrincipal();
  },
  data() {
    return {
      dialogAnalisisIa: false,
      seleccionArchivosFacturaIa: null,
      paginasFacturaIa: [],
      indicePaginaFacturaIa: 0,
      maximoPaginasFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.paginasMaximas,
      tamanoMaximoBytesFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.tamanoMaximoBytes,
      dimensionMinimaAzureFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.dimensionMinimaAzure,
      dimensionMaximaAzureFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.dimensionMaximaAzure,
      ladoMenorMinimoFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.ladoMenorMinimo,
      ladoMenorRecomendadoFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.ladoMenorRecomendado,
      brilloMinimoFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.brilloMinimo,
      brilloMaximoFacturaIa: UMBRALES_CALIDAD_IMAGEN_FACTURA_IA.brilloMaximo,
      tipoArchivoFacturaIa: null,
      paginaPdfFacturaIa: 1,
      totalPaginasPdfFacturaIa: 0,
      cargandoPdfFacturaIa: false,
      validandoCalidadFacturaIa: false,
      errorVistaPreviaFacturaIa: "",
      analizandoFacturaIa: false,
      resultadoFacturaIa: null,
      advertenciasFacturaIa: [],
      erroresFacturaIa: [],
      gruposValidacionFacturaIa: [],
      mensajeAnalisisIa: "",
      detalleMensajesCargaFacturaIa: [],
      tipoMensajeAnalisisIa: "info",
      umbralPendientesCatalogoIa: 50,
      preparandoCatalogoIa: false,
      snackbarCatalogoIa: false,
      pendientesCatalogoIa: 0,
      intervaloCatalogoIa: null,
      confirmacionRevisionIa: false,
      haRevisadoFacturaIa: false,
      omitirFilaVaciaAutomatica: false,
      isActive:false,
      objobj: null,
      windowSize: { width: "auto", height: "auto" },
      valid: true,
      ejecucion: true,
      EjecutarPermisoPv: false,
      ObjEjecPermisoPv: null,
      dialogOrdenSugerida: false,
      dialogimprimirList: false,
      dialogImprimirEtiqueta: false,
      dialogCargerImagen: false,
      loadercargarFoto: false,
      listObjFoto: [],
      objCargaImg: {
        codigo: 0,
        codigofactura: 0,
        documentofactura: 0,
        cargaImg: null,
        imgView: '',
      },

      InputDisabled: false,
      ImprirEtiqueta: {
        selectImpresora: null,
        seleCtTerminar: null,
        ImpesoraBarra: null,
        desde: ' fechaNueva()',
      },
      datosImprecion: {
        nombre: "REGISTRO FACTURAS DE PROVEEDORES",
        UrlImprimir: "/facturasproveedor/imprimir",
        UrlExel: "/facturasproveedor/excel",
        UrlCorreo: "/facturasproveedor/correo",
      },
      configuraciones: null,
      listaProducImprir:[],
      dialogimprimirListFilt: false,
      datosImprecionAll: {
        nombre: "LISTADO DE REGISTRO FACTURAS DE PROVEEDORES",
        UrlImprimir: "/facturasproveedor/ImprimirList",
        UrlExel: "/facturasproveedor/ExcelList",
        UrlCorreo: "/facturasproveedor/CorreoList",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        documentos: null,
        FecRegi: false,
        soloNcf: false
      },
      ActualizaAlmacen: false,
      almacen: null,
      TotalProd: {
        cantidad: 0,
        cantExit: 0,
        costo: 0,
        subtotal: 0,
        impuesto: 0,
        descuento: 0,
        importe: 0,
      },
      ListProd: [],

      dialogFiltros: false,
      Modallfiltro: {
        proveedores: null,
        factura: null,
        documento: null,
        Desde: null,
        Hasta: null,
      },

      ObjTemTbDinam: null,
      ListItems: [],
      TbTotalItem: 0,
      TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      Rmoneda: [],
      Rproveedor: [],
      RallProducto: [],
      Rdepartamento: [],
      RlistFormato: [],
      RlistImpresora: [],
      Ralmacen: [],
      RDocumento: [],
      RTipoGasto: [],
      acti_Modal_cuenta: false,
      objeTem: null,
      TotalCuenta: null,
      RLisCuenta: [],
      contabilidad: null,
      dialogRestaurarTemporal: false,
      RestaurarTempList: [],
      objRestaurarTemp: null,
      aalert: {
        estado: false,
        color: null,
      },
      notif: {
        estado: false,
        nombre: "",
        Exec: "",
      },
      search: "",
      ObjTemp: null,
      OrdenCompra: {
        desde: fechaNueva(),
        hasta: fechaNueva(),
        dia: 0,
        proveedor: null,
        almacen: null,
        opcion: 1,
      },
      datosNCF: {
        secuencia: "",
        codigoFijo: "",
      },
      secuenciaRef: undefined,
      dialogProveedorOrdenCompra: false,
      ProveedorOrdenCompraSelected: [],
      ProveedorOrdenCompra: [],
      FacturaProveedor: {
        facturasProveedoresPK: { codigo: 0, documento: 0 },
        empresa: null,
        fecha: fechaNueva(),
        referencia: "",
        ordencompra: null,
        diascredito: 0,
        tipogasto: 0,
        tiposuplidor: null,
        ncf: "",
        totalimpuesto: 0,
        totaldescuento: 0,
        total: 0.0,
        comentario: null,
        tasa: 0,
        pendiente: 0.0,
        activada: true,
        fechaCreacion: fechaNueva(),
        fechaModificacion: null,
        usuarioCreacion: "",
        usuarioModificacion: null,
        selectivo: 0.0,
        facturaGastos: false,
        itbisincluido: false,
        pagosuspendido: false,
        comentarioSuspencion: "",
        descuentoIdividual: 0,
        borrado: false,
        detalleJson: "",
        documentoproveedor: "",
        moneda: null,
        proveedor: null,
        facturasProveedoresDetalleList: [],
        totaldescuento: 0,
        totalimpuesto: 0,
        listFoto: []
      },
      tipogasto: null,
      RLisCuenta: [],
      editCuentasC:false,
      diasCredito: 0,
      TotalCuenta: {
        credito: 0,
        debito: 0,
      },
      EstadoBtn: {
        BarraTablaDinamicaAprir: true,
        nuevo: true,
        guardar: !this.modoIa,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: true,
        guardartemporal: !this.modoIa,
        restaurartemporal: true,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
        reimprimirEtiqueta: false,
        mostrarAnalisisIa: true
      },
      TipoProveedor: {
        codigo: 0,
        nombre: null,
        porciento: 0,
      },
      rules: {
        required: (value) => !!value || "Required.",
        edad: [
          (val) => val > 10 || `Edad debe ser mayor a 10`,
          (val) => val < 70 || `Edad debe ser menor a 120`,
        ],
        porciento: (value) => value <= 100 || `Porciento debe ser  menor a 100`,
        counter: (value) =>
          (value && value.length <= 50) || "Max 20 characters",
        RTel: (value) => value != 10 || `telefono debe tener 10 digitos`,
        ncfLimit: () => (this.datosNCF.codigoFijo.trim().length + this.datosNCF.secuencia.trim().length) <= 20 || "Maximo 20 caracteres"
      },
      headers: [{ text: "Tarjeta", value: "nombre" }],
      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        { dt0: "nombre", dt1: null, dt2: null, dt3: 1, dt4: "nombre:" },
        { dt0: "porciento", dt1: null, dt2: null, dt3: 5, dt4: "Porciento:" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,
      searchByCodigo: false,
    };
  },

  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    fechaNueva,
    getParamFecha,
    RedondeoBasico,
    getFechaZone,
    RedondeoValorCantRed,
    async manejarSeleccionArchivosFacturaIa(archivosSeleccionados) {
      this.limpiarResultadoIa();
      this.errorVistaPreviaFacturaIa = "";
      var archivos = this.normalizarListaArchivosFacturaIa(archivosSeleccionados);
      this.seleccionArchivosFacturaIa = null;
      if (!archivos.length)
        return;
      var validacion = this.validarArchivosNuevosFacturaIa(archivos);
      if (!validacion.esValido) {
        this.mostrarErrorCargaFacturaIa(validacion.mensaje);
        return;
      }
      if (validacion.reemplazarPaginas)
        this.limpiarPaginasFacturaIa();
      var esPdf = this.obtenerTipoArchivoFacturaIa(archivos[0]) === "PDF";
      if (esPdf) {
        this.agregarPaginasFacturaIa(archivos.map((archivo) => this.crearPaginaFacturaIa(archivo)));
        this.paginaPdfFacturaIa = 1;
        this.totalPaginasPdfFacturaIa = 0;
        this.cargandoPdfFacturaIa = true;
        return;
      }
      this.validandoCalidadFacturaIa = true;
      try {
        var resultadoCalidad = await this.filtrarFotosPorCalidadFacturaIa(archivos);
        if (!resultadoCalidad.paginas.length) {
          this.mostrarErrorCargaFacturaIa(
            "Ninguna foto cumple la calidad mínima.",
            resultadoCalidad.errores
          );
          return;
        }
        this.agregarPaginasFacturaIa(resultadoCalidad.paginas);
        this.mostrarMensajeCargaFacturaIa(
          resultadoCalidad.errores,
          resultadoCalidad.paginas.length
        );
      } finally {
        this.validandoCalidadFacturaIa = false;
      }
    },
    async filtrarFotosPorCalidadFacturaIa(archivos) {
      var paginas = [];
      var errores = [];
      var umbrales = {
        dimensionMinimaAzure: this.dimensionMinimaAzureFacturaIa,
        dimensionMaximaAzure: this.dimensionMaximaAzureFacturaIa,
        ladoMenorMinimo: this.ladoMenorMinimoFacturaIa,
        ladoMenorRecomendado: this.ladoMenorRecomendadoFacturaIa,
        brilloMinimo: this.brilloMinimoFacturaIa,
        brilloMaximo: this.brilloMaximoFacturaIa
      };
      for (var indice = 0; indice < archivos.length; indice++) {
        var archivo = archivos[indice];
        var calidad = await analizarCalidadImagenFacturaIa(archivo, umbrales);
        if (!calidad.esValida) {
          errores = errores.concat(calidad.errores);
          continue;
        }
        paginas.push(this.crearPaginaFacturaIa(archivo, calidad));
      }
      return {
        paginas: paginas,
        errores: errores
      };
    },
    agregarPaginasFacturaIa(paginasNuevas) {
      if (!paginasNuevas.length)
        return;
      var indiceInicial = this.paginasFacturaIa.length;
      this.paginasFacturaIa = this.paginasFacturaIa.concat(paginasNuevas);
      this.actualizarTipoArchivoFacturaIa();
      this.indicePaginaFacturaIa = indiceInicial;
    },
    mostrarMensajeCargaFacturaIa(errores, cantidadAceptadas) {
      this.detalleMensajesCargaFacturaIa = errores && errores.length ? errores.slice() : [];
      if (cantidadAceptadas > 1) {
        this.mensajeAnalisisIa = "Varias fotos se unen en un PDF para analizar.";
      } else if (errores && errores.length) {
        this.mensajeAnalisisIa = "Algunas fotos no se agregaron por calidad.";
      } else {
        this.mensajeAnalisisIa = "";
      }
      this.tipoMensajeAnalisisIa = errores && errores.length ? "error" : "info";
    },
    mostrarErrorCargaFacturaIa(mensaje, detalles) {
      this.mensajeAnalisisIa = mensaje;
      this.detalleMensajesCargaFacturaIa = detalles && detalles.length ? detalles.slice() : [];
      this.tipoMensajeAnalisisIa = "error";
    },
    normalizarListaArchivosFacturaIa(archivosSeleccionados) {
      if (!archivosSeleccionados)
        return [];
      if (Array.isArray(archivosSeleccionados))
        return archivosSeleccionados.filter((archivo) => !!archivo);
      return [archivosSeleccionados];
    },
    validarArchivosNuevosFacturaIa(archivos) {
      var cantidadPdf = 0;
      var cantidadImagenes = 0;
      var tamanoSeleccion = 0;
      for (var indice = 0; indice < archivos.length; indice++) {
        var archivo = archivos[indice];
        var tipo = this.obtenerTipoArchivoFacturaIa(archivo);
        if (!tipo) {
          return {
            esValido: false,
            mensaje: "Solo se permiten archivos PDF, JPG y PNG.",
            reemplazarPaginas: false
          };
        }
        if (archivo.size > this.tamanoMaximoBytesFacturaIa) {
          return {
            esValido: false,
            mensaje: "El archivo \"" + archivo.name + "\" supera el tamaño máximo de "
              + this.formatearTamanoArchivoIa(this.tamanoMaximoBytesFacturaIa) + ".",
            reemplazarPaginas: false
          };
        }
        tamanoSeleccion += archivo.size;
        if (tipo === "PDF")
          cantidadPdf++;
        else
          cantidadImagenes++;
      }
      if (cantidadPdf && cantidadImagenes) {
        return {
          esValido: false,
          mensaje: "No mezcle PDF + fotos en el mismo envío. Use un PDF o solo fotos.",
          reemplazarPaginas: false
        };
      }
      if (cantidadPdf > 1) {
        return {
          esValido: false,
          mensaje: "Solo se permite un archivo PDF por análisis.",
          reemplazarPaginas: false
        };
      }
      if (cantidadPdf === 1) {
        if (tamanoSeleccion > this.tamanoMaximoBytesFacturaIa) {
          return {
            esValido: false,
            mensaje: "El PDF supera el tamaño máximo de "
              + this.formatearTamanoArchivoIa(this.tamanoMaximoBytesFacturaIa) + ".",
            reemplazarPaginas: false
          };
        }
        return {
          esValido: true,
          mensaje: "",
          reemplazarPaginas: true
        };
      }
      if (this.tipoArchivoFacturaIa === "PDF" && this.paginasFacturaIa.length) {
        return {
          esValido: false,
          mensaje: "No mezcle PDF + fotos. Quite el PDF antes de agregar fotos.",
          reemplazarPaginas: false
        };
      }
      if (archivos.length > this.maximoPaginasFacturaIa) {
        return {
          esValido: false,
          mensaje: "Máximo " + this.maximoPaginasFacturaIa
            + " fotos. Seleccionó " + archivos.length + ".",
          reemplazarPaginas: false
        };
      }
      if (this.paginasFacturaIa.length + archivos.length > this.maximoPaginasFacturaIa) {
        var disponibles = this.maximoPaginasFacturaIa - this.paginasFacturaIa.length;
        return {
          esValido: false,
          mensaje: "Máximo " + this.maximoPaginasFacturaIa + " fotos. Ya tiene "
            + this.paginasFacturaIa.length + " y solo puede agregar "
            + Math.max(disponibles, 0) + " más.",
          reemplazarPaginas: false
        };
      }
      var tamanoTotal = this.tamanoTotalPaginasFacturaIa + tamanoSeleccion;
      if (tamanoTotal > this.tamanoMaximoBytesFacturaIa) {
        return {
          esValido: false,
          mensaje: "El conjunto de fotos supera el tamaño máximo de "
            + this.formatearTamanoArchivoIa(this.tamanoMaximoBytesFacturaIa)
            + ". Actual: " + this.formatearTamanoArchivoIa(tamanoTotal) + ".",
          reemplazarPaginas: false
        };
      }
      return {
        esValido: true,
        mensaje: "",
        reemplazarPaginas: false
      };
    },
    obtenerTipoArchivoFacturaIa(archivo) {
      if (!archivo)
        return null;
      var nombreArchivo = archivo.name ? archivo.name.toLowerCase() : "";
      var extension = nombreArchivo.includes(".")
        ? nombreArchivo.substring(nombreArchivo.lastIndexOf("."))
        : "";
      var tiposPermitidos = ["application/pdf", "image/jpeg", "image/png"];
      var extensionesPermitidas = [".pdf", ".jpg", ".jpeg", ".png"];
      var tieneTipoValido = !archivo.type || tiposPermitidos.includes(archivo.type.toLowerCase());
      var tieneExtensionValida = extensionesPermitidas.includes(extension);
      if (!tieneTipoValido || !tieneExtensionValida)
        return null;
      return extension === ".pdf" ? "PDF" : "IMAGEN";
    },
    crearPaginaFacturaIa(archivo, calidad) {
      return {
        id: Date.now() + "-" + Math.random().toString(36).slice(2),
        archivo: archivo,
        nombre: archivo.name,
        tamano: archivo.size,
        tipo: this.obtenerTipoArchivoFacturaIa(archivo),
        url: URL.createObjectURL(archivo),
        ancho: calidad ? calidad.ancho : null,
        alto: calidad ? calidad.alto : null,
        advertencias: calidad && calidad.advertencias ? calidad.advertencias.slice() : []
      };
    },
    actualizarTipoArchivoFacturaIa() {
      if (!this.paginasFacturaIa.length) {
        this.tipoArchivoFacturaIa = null;
        return;
      }
      this.tipoArchivoFacturaIa = this.paginasFacturaIa[0].tipo === "PDF" ? "PDF" : "IMAGEN";
    },
    seleccionarPaginaFacturaIa(indice) {
      if (indice < 0 || indice >= this.paginasFacturaIa.length)
        return;
      this.indicePaginaFacturaIa = indice;
      this.errorVistaPreviaFacturaIa = "";
    },
    moverPaginaFacturaIa(indice, desplazamiento) {
      var nuevoIndice = indice + desplazamiento;
      if (nuevoIndice < 0 || nuevoIndice >= this.paginasFacturaIa.length)
        return;
      var paginas = this.paginasFacturaIa.slice();
      var pagina = paginas.splice(indice, 1)[0];
      paginas.splice(nuevoIndice, 0, pagina);
      this.paginasFacturaIa = paginas;
      if (this.indicePaginaFacturaIa === indice)
        this.indicePaginaFacturaIa = nuevoIndice;
      else if (this.indicePaginaFacturaIa === nuevoIndice)
        this.indicePaginaFacturaIa = indice;
    },
    quitarPaginaFacturaIa(indice) {
      if (indice < 0 || indice >= this.paginasFacturaIa.length)
        return;
      var pagina = this.paginasFacturaIa[indice];
      if (pagina && pagina.url)
        URL.revokeObjectURL(pagina.url);
      this.paginasFacturaIa.splice(indice, 1);
      this.actualizarTipoArchivoFacturaIa();
      if (!this.paginasFacturaIa.length) {
        this.indicePaginaFacturaIa = 0;
        this.paginaPdfFacturaIa = 1;
        this.totalPaginasPdfFacturaIa = 0;
        this.cargandoPdfFacturaIa = false;
        return;
      }
      if (this.indicePaginaFacturaIa >= this.paginasFacturaIa.length)
        this.indicePaginaFacturaIa = this.paginasFacturaIa.length - 1;
    },
    limpiarPaginasFacturaIa() {
      this.paginasFacturaIa.forEach((pagina) => {
        if (pagina && pagina.url)
          URL.revokeObjectURL(pagina.url);
      });
      this.paginasFacturaIa = [];
      this.indicePaginaFacturaIa = 0;
      this.tipoArchivoFacturaIa = null;
      this.paginaPdfFacturaIa = 1;
      this.totalPaginasPdfFacturaIa = 0;
      this.cargandoPdfFacturaIa = false;
      this.errorVistaPreviaFacturaIa = "";
      this.seleccionArchivosFacturaIa = null;
    },
    liberarVistaPreviaFacturaIa() {
      this.limpiarPaginasFacturaIa();
    },
    manejarPdfFacturaIaRenderizado() {
      this.cargandoPdfFacturaIa = false;
      if (this.$refs.pdfFacturaIa)
        this.totalPaginasPdfFacturaIa = this.$refs.pdfFacturaIa.pageCount || 1;
    },
    manejarErrorVistaPdfFacturaIa() {
      this.cargandoPdfFacturaIa = false;
      this.errorVistaPreviaFacturaIa = "El navegador no pudo mostrar la vista previa del PDF seleccionado.";
    },
    manejarErrorVistaImagenFacturaIa() {
      this.errorVistaPreviaFacturaIa = "El navegador no pudo mostrar la imagen seleccionada.";
    },
    formatearTamanoArchivoIa(tamanoBytes) {
      if (!tamanoBytes)
        return "0 KB";
      var tamanoKilobytes = tamanoBytes / 1024;
      if (tamanoKilobytes < 1024)
        return tamanoKilobytes.toFixed(1) + " KB";
      return (tamanoKilobytes / 1024).toFixed(2) + " MB";
    },
    limpiarResultadoIa() {
      this.resultadoFacturaIa = null;
      this.advertenciasFacturaIa = [];
      this.erroresFacturaIa = [];
      this.gruposValidacionFacturaIa = [];
      this.mensajeAnalisisIa = "";
      this.detalleMensajesCargaFacturaIa = [];
      this.confirmacionRevisionIa = false;
      this.haRevisadoFacturaIa = false;
    },
    async analizarFacturaIa() {
      if (!this.paginasFacturaIa.length || !this.tipoArchivoFacturaIa) {
        this.mostrarErrorCargaFacturaIa(
          "Seleccione 1 PDF o hasta " + this.maximoPaginasFacturaIa + " fotos JPG/PNG."
        );
        return;
      }
      if (this.tipoArchivoFacturaIa === "IMAGEN"
        && this.paginasFacturaIa.length > this.maximoPaginasFacturaIa) {
        this.mostrarErrorCargaFacturaIa(
          "Máximo " + this.maximoPaginasFacturaIa + " fotos. Ahora tiene "
          + this.paginasFacturaIa.length + "."
        );
        return;
      }
      if (this.tamanoTotalPaginasFacturaIa > this.tamanoMaximoBytesFacturaIa) {
        this.mostrarErrorCargaFacturaIa(
          "El envío supera el tamaño máximo de "
          + this.formatearTamanoArchivoIa(this.tamanoMaximoBytesFacturaIa)
          + ". Actual: " + this.formatearTamanoArchivoIa(this.tamanoTotalPaginasFacturaIa) + "."
        );
        return;
      }
      this.limpiarResultadoIa();
      this.analizandoFacturaIa = true;
      this.sincronizarEmbeddingsFacturaIaEnBackground();
      var formulario = new FormData();
      if (this.paginasFacturaIa.length === 1)
        formulario.append("archivo", this.paginasFacturaIa[0].archivo);
      else {
        this.paginasFacturaIa.forEach((pagina) => {
          formulario.append("archivos", pagina.archivo);
        });
      }
      var encabezados = Object.assign({}, this.$store.getters.GetheadersAxios);
      delete encabezados["Content-Type"];
      try {
        var respuesta = await this.$axios.post(
          this.$hostname + this.$hName + "/facturasproveedor-ia/analizar",
          formulario,
          { headers: encabezados }
        );
        await this.procesarResultadoFacturaIa(respuesta.data);
      } catch (error) {
        var respuestaError = error.response;
        var tieneResultadoAnalizado = respuestaError
          && (respuestaError.status === 400 || respuestaError.status === 422)
          && respuestaError.data
          && respuestaError.data.datos;
        if (tieneResultadoAnalizado) {
          await this.procesarResultadoFacturaIa(error.response.data);
        } else {
          var datosError = respuestaError ? respuestaError.data : null;
          var mensajeValidacion = datosError && datosError.validacion
            ? datosError.validacion.mensaje
            : null;
          this.mensajeAnalisisIa = mensajeValidacion
            || (datosError && datosError.mensaje)
            || "No fue posible analizar la factura.";
          this.tipoMensajeAnalisisIa = "error";
        }
      } finally {
        this.analizandoFacturaIa = false;
      }
    },
    sincronizarEmbeddingsFacturaIaEnBackground() {
      if (!this.modoIa)
        return;
      var self = this;
      var encabezados = Object.assign({}, this.$store.getters.GetheadersAxios);
      // Fire-and-forget: no loading global ni bloqueo de pantalla.
      this.$axios.post(
        this.$hostname + this.$hName + "/facturasproveedor-ia/sincronizar-embeddings",
        null,
        { headers: encabezados }
      ).then(function (respuesta) {
        var datos = respuesta && respuesta.data ? respuesta.data : {};
        var pendientes = Number(datos.pendientes || 0);
        self.pendientesCatalogoIa = pendientes;
        if (datos.iniciado && pendientes >= self.umbralPendientesCatalogoIa) {
          self.preparandoCatalogoIa = true;
          self.snackbarCatalogoIa = true;
          self.iniciarMonitoreoCatalogoIa();
        } else if (pendientes <= 0) {
          self.cerrarMensajeCatalogoIa();
        }
      }).catch(function () {
        // Soft-fail: la sync no debe bloquear Factura IA.
      });
    },
    iniciarMonitoreoCatalogoIa() {
      var self = this;
      if (this.intervaloCatalogoIa)
        return;
      this.intervaloCatalogoIa = setInterval(function () {
        self.consultarEstadoCatalogoIa();
      }, 15000);
    },
    detenerMonitoreoCatalogoIa() {
      if (this.intervaloCatalogoIa) {
        clearInterval(this.intervaloCatalogoIa);
        this.intervaloCatalogoIa = null;
      }
    },
    consultarEstadoCatalogoIa() {
      if (!this.modoIa)
        return;
      var self = this;
      this.$axios.get(
        this.$hostname + this.$hName + "/facturasproveedor-ia/embeddings-estado",
        { headers: this.$store.getters.GetheadersAxios }
      ).then(function (respuesta) {
        var datos = respuesta && respuesta.data ? respuesta.data : {};
        var pendientes = Number(datos.pendientes || 0);
        self.pendientesCatalogoIa = pendientes;
        if (pendientes <= 0 || datos.preparando === false) {
          self.cerrarMensajeCatalogoIa();
          return;
        }
        self.preparandoCatalogoIa = true;
        self.snackbarCatalogoIa = true;
      }).catch(function () {
        // Soft-fail: no tumba la pantalla si falla el estado.
      });
    },
    cerrarMensajeCatalogoIa() {
      this.preparandoCatalogoIa = false;
      this.snackbarCatalogoIa = false;
      this.detenerMonitoreoCatalogoIa();
    },
    async procesarResultadoFacturaIa(resultado) {
      this.resultadoFacturaIa = resultado;
      this.advertenciasFacturaIa = resultado.advertencias || [];
      this.erroresFacturaIa = resultado.validacion && resultado.validacion.errores
        ? resultado.validacion.errores
        : [];
      this.gruposValidacionFacturaIa = this.agruparValidacionesFacturaIa(
        this.advertenciasFacturaIa,
        this.erroresFacturaIa
      );
      this.mensajeAnalisisIa = resultado.validacion && resultado.validacion.mensaje
        ? resultado.validacion.mensaje
        : "Análisis completado. Revise todos los campos.";
      this.tipoMensajeAnalisisIa = this.erroresFacturaIa.length ? "warning" : "success";
      await this.cargarDatosFacturaIa(resultado.datos);
    },
    agruparValidacionesFacturaIa(advertencias, errores) {
      var grupos = {};
      var lineasProductos = new Set();
      var camposPrincipales = new Set();
      var mensajesProcesados = new Set();
      var validaciones = errores.map((mensaje) => ({ mensaje: mensaje, esError: true }))
        .concat(advertencias.map((mensaje) => ({ mensaje: mensaje, esError: false })));
      validaciones.forEach((validacion) => {
        var mensaje = validacion.mensaje;
        var productoEncontrado = mensaje.match(/Producto no encontrado en la línea (\d+)/i);
        if (productoEncontrado) {
          lineasProductos.add(Number(productoEncontrado[1]));
          return;
        }
        var campoDetalle = mensaje.match(/facturasProveedoresDetalleList\[(\d+)\]\.([A-Za-z]+)/);
        if (campoDetalle)
          return;
        var campoPrincipal = mensaje.match(/^(?:Revise|El campo)\s+([A-Za-z]+).*confianza/i);
        if (campoPrincipal) {
          camposPrincipales.add(campoPrincipal[1]);
          return;
        }
        var claveMensaje = mensaje.trim().toLowerCase();
        if (mensajesProcesados.has(claveMensaje))
          return;
        mensajesProcesados.add(claveMensaje);
        this.agregarValidacionAgrupadaIa(grupos, mensaje, validacion.esError);
      });
      if (lineasProductos.size)
        this.agregarMensajeGrupoIa(
          grupos,
          "productos",
          "Seleccione manualmente el producto y la unidad en las líneas: "
            + Array.from(lineasProductos).sort((a, b) => a - b).join(", "),
          true
        );
      if (camposPrincipales.size)
        this.agregarMensajeGrupoIa(
          grupos,
          "camposPrincipales",
          "Campos con confianza baja: " + Array.from(camposPrincipales).join(", "),
          true
        );
      return Object.keys(grupos).map((categoria) => grupos[categoria]);
    },
    agregarValidacionAgrupadaIa(grupos, mensaje, esError) {
      var texto = mensaje.toLowerCase();
      var categoria = "documento";
      if (texto.includes("proveedor") || texto.includes("rnc"))
        categoria = "proveedor";
      else if (texto.includes("ncf"))
        categoria = "fiscal";
      else if (texto.includes("total") || texto.includes("subtotal") || texto.includes("importe"))
        categoria = "totales";
      else if (texto.includes("producto") || texto.includes("línea"))
        categoria = "productos";
      else if (texto.includes("confianza"))
        categoria = "camposPrincipales";
      this.agregarMensajeGrupoIa(grupos, categoria, mensaje, esError);
    },
    agregarMensajeGrupoIa(grupos, categoria, mensaje, esError) {
      var titulos = {
        camposPrincipales: "Campos principales que requieren corrección",
        productos: "Productos pendientes de relacionar",
        proveedor: "Proveedor",
        fiscal: "Información fiscal",
        totales: "Totales",
        documento: "Otras verificaciones",
      };
      if (!grupos[categoria])
        grupos[categoria] = {
          categoria: categoria,
          titulo: titulos[categoria],
          tipo: esError ? "error" : "warning",
          mensajes: [],
        };
      if (esError)
        grupos[categoria].tipo = "error";
      if (!grupos[categoria].mensajes.includes(mensaje))
        grupos[categoria].mensajes.push(mensaje);
    },
    async cargarDatosFacturaIa(datos) {
      if (!datos)
        return;
      var proveedor = await this.obtenerEntidadFacturaIa("/proveedores/find/", datos.proveedorMicromarket, "nombre");
      if (proveedor) {
        proveedor.nombre = proveedor.nombre
          || datos.proveedorMicromarket.descripcion
          || datos.nombreProveedor;
        this.incluirProveedorFacturaIa(proveedor);
      }
      var moneda = await this.obtenerMonedaFacturaIa(datos.monedaMicromarket);
      this.omitirFilaVaciaAutomatica = true;
      try {
        this.ListProd = [];
        this.FacturaProveedor = Object.assign({}, this.FacturaProveedor, {
          facturasProveedoresPK: { codigo: 0, documento: 0 },
          fecha: this.normalizarFechaFacturaIa(datos.fecha) || this.fechaNueva(),
          referencia: datos.referencia || "",
          diascredito: datos.diascredito || 0,
          ncf: datos.ncf || "",
          totalimpuesto: datos.totalimpuesto || 0,
          totaldescuento: datos.totaldescuento || 0,
          total: datos.total || 0,
          pendiente: datos.total || 0,
          proveedor: proveedor,
          moneda: moneda,
          tasa: moneda && moneda.tasa ? moneda.tasa : 0,
          facturasProveedoresDetalleList: [],
        });
        this.asignarNcfFacturaIa(datos.ncf);
        var detalles = datos.facturasProveedoresDetalleList || [];
        for (var indice = 0; indice < detalles.length; indice += 1)
          await this.agregarDetalleFacturaIa(detalles[indice]);
        this.quitarFilasVaciasInicioFacturaIa();
      } finally {
        this.omitirFilaVaciaAutomatica = false;
      }
    },
    /**
     * Red de seguridad: quita filas vacías al inicio (producto null, sin limpia IA, sin esDetalleIa).
     */
    quitarFilasVaciasInicioFacturaIa() {
      while (this.ListProd.length > 0) {
        var primera = this.ListProd[0];
        if (primera.esDetalleIa === true)
          break;
        if (primera.producto != null)
          break;
        var limpia = (primera.descripcionLimpia || primera.descripcionIa || "").trim();
        if (limpia)
          break;
        this.ListProd.shift();
      }
    },
    incluirProveedorFacturaIa(proveedor) {
      var existeProveedor = this.Rproveedor.some(
        (proveedorDisponible) => proveedorDisponible.codigo === proveedor.codigo
      );
      if (!existeProveedor)
        this.Rproveedor.unshift(proveedor);
    },
    async agregarDetalleFacturaIa(detalle) {
      var producto = await this.obtenerEntidadFacturaIa("/producto/", detalle.productoMicromarket, "descripcion");
      var unidad = await this.obtenerEntidadFacturaIa("/unidad/", detalle.unidadMicromarket, "descripcion");
      var descripcionLimpia = (detalle.descripcionLimpia || detalle.descripcion || "").trim();
      var estadoRevision = detalle.estadoRevision || (producto ? "CONFIRMAR" : "SIN");
      var productoNoEncontrado = !producto || !producto.codigo || estadoRevision === "SIN";
      // Sin producto: solo descripción limpia; montos en 0 para no alterar el total.
      var cantidad = productoNoEncontrado ? 0 : (detalle.cantidad || 0);
      var precio = productoNoEncontrado ? 0 : (detalle.precio || 0);
      var valor = productoNoEncontrado ? 0 : (detalle.valor || 0);
      var impuesto = productoNoEncontrado ? 0 : (detalle.impuesto || 0);
      var descuento = productoNoEncontrado ? 0 : (detalle.descuento || 0);
      await this.$refs.detalle.addDetalleOrdenAFactura({
        esDetalleIa: true,
        codigoProducto: productoNoEncontrado ? "" : (detalle.codigoProducto || ""),
        descripcionIa: descripcionLimpia,
        descripcionLimpia: descripcionLimpia,
        estadoRevision: productoNoEncontrado ? "SIN" : estadoRevision,
        fechavencimiento: productoNoEncontrado ? null : this.normalizarFechaFacturaIa(detalle.fechavencimiento),
        cantidad: cantidad,
        precio: precio,
        valor: valor,
        impuesto: impuesto,
        descuento: descuento,
        impuestoIncluido: false,
        producto: productoNoEncontrado ? null : producto,
        unidad: productoNoEncontrado ? null : unidad,
        ofertaSelect: productoNoEncontrado ? false : (detalle.oferta === true),
        descuentoPorciento: false,
        loteFabricante: productoNoEncontrado ? "" : (detalle.loteFabricante || ""),
      });
      this.$refs.detalle.calcularTotales();
      this.sincronizarTotalesFacturaIa();
    },
    sincronizarTotalesFacturaIa() {
      var totales = this.$refs.detalle.TotalProd;
      this.TotalProd = JSON.parse(JSON.stringify(totales));
      this.FacturaProveedor.subtotal = totales.subtotal || 0;
      this.FacturaProveedor.totalimpuesto = totales.impuesto || 0;
      this.FacturaProveedor.totaldescuento = totales.descuento || 0;
      this.FacturaProveedor.total = totales.importe || 0;
      this.FacturaProveedor.pendiente = totales.importe || 0;
    },
    normalizarFechaFacturaIa(fecha) {
      if (Array.isArray(fecha) && fecha.length >= 3) {
        var ano = fecha[0].toString().padStart(4, "0");
        var mes = fecha[1].toString().padStart(2, "0");
        var dia = fecha[2].toString().padStart(2, "0");
        return ano + "-" + mes + "-" + dia;
      }
      if (typeof fecha === "string" && fecha.length >= 10)
        return fecha.substring(0, 10);
      return null;
    },
    async obtenerEntidadFacturaIa(ruta, referencia, campoDescripcion) {
      if (!referencia || !referencia.codigo)
        return null;
      try {
        var respuesta = await this.$axios.get(
          this.$hostname + this.$hName + ruta + referencia.codigo,
          { headers: this.$store.getters.GetheadersAxios }
        );
        if (respuesta.data)
          return respuesta.data;
      } catch (error) {
      }
      var entidad = { codigo: referencia.codigo };
      entidad[campoDescripcion] = referencia.descripcion;
      return entidad;
    },
    async obtenerMonedaFacturaIa(referencia) {
      if (!referencia || !referencia.codigo)
        return null;
      try {
        var respuesta = await this.$axios.get(
          this.$hostname + this.$hName + "/monedas/findallActivos/",
          { headers: this.$store.getters.GetheadersAxios }
        );
        return respuesta.data.find((moneda) => moneda.codigo === referencia.codigo) || null;
      } catch (error) {
        return { codigo: referencia.codigo, nombrecorto: referencia.descripcion, tasa: 1 };
      }
    },
    asignarNcfFacturaIa(ncf) {
      this.datosNCF.codigoFijo = "";
      this.datosNCF.secuencia = "";
      if (!ncf)
        return;
      var ncfNormalizado = ncf.trim();
      var longitudPrefijo = ncfNormalizado.charAt(0).toUpperCase() === "E" ? 3 : 3;
      this.datosNCF.codigoFijo = ncfNormalizado.substring(0, longitudPrefijo);
      this.datosNCF.secuencia = ncfNormalizado.substring(longitudPrefijo);
    },
    confirmarRevisionFacturaIa() {
      if (!this.confirmacionRevisionIa) {
        this.alerta("Marque que revisó y corrigió los datos antes de confirmar.", "error");
        return;
      }
      this.haRevisadoFacturaIa = true;
      this.dialogAnalisisIa = false;
      this.alerta("Datos revisados. Ya puede guardar la factura.", "bien");
    },
    /**
     * Regla 5.5: no persistir factura IA sin revisión/confirmación explícita.
     * @returns {boolean} true si puede continuar el guardado.
     */
    asegurarRevisionConfirmadaFacturaIa() {
      if (!this.modoIa)
        return true;
      if (this.haRevisadoFacturaIa)
        return true;
      this.alerta(
        "Debe confirmar que revisó los datos cargados por la IA antes de guardar.",
        "error"
      );
      this.dialogAnalisisIa = true;
      return false;
    },
    onResize(e) {
      //this.windowSize=e
    },
    MethodReimprimirEtiqueta(){
      this.dialogImprimirEtiqueta = true

      this.listaProducImprir=JSON.parse(JSON.stringify(this.FacturaProveedor.facturasProveedoresDetalleList))

  //  if(this.$store.getters.GetConfiguracionGeneral.configCxp.hasOwnProperty('cambiarCantidadEtiqueta') && this.configuraciones.configCxp.cambiarCantidadEtiqueta  == true){
  //     this.listaProducImprir=JSON.parse(JSON.stringify(this.FacturaProveedor.facturasProveedoresDetalleList))
  //  }     
        
    },
    findAlmacenPrincipal() {
      this.$axios
        .get(this.$hostname + this.$hName + "/almacen/principal", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.almacen = res.data;
        });
    },
    Saavetem() {
      if (!this.asegurarRevisionConfirmadaFacturaIa())
        return;
      if (this.$refs.formFactPro.validate()) {
        EventBus.$emit("loading", true);
        this.llenarTemporal();
        //EventBus.$emit("loading", true);
        this.FacturaTemporal.ncf = this.datosNCF.codigoFijo.trim() + this.datosNCF.secuencia.trim();
        this.FacturaTemporal.fecha = this.getFechaZone(this.FacturaTemporal.fecha)
        if (this.tipogasto != null) { this.FacturaTemporal.tipogasto = this.tipogasto.codigo }
        /*console.log('------- Informacion ----')
        console.log(this.objobj)
        EventBus.$emit("loading", false);
        this.ejecucion = true;
        return  this.FacturaTemporal       */
        this.$axios
          .post(
            this.$hostname + this.$hName + "/facturasproveedor/salvarTemporal",
            this.FacturaTemporal,
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
            if (res.data) {
              // if (this.RestaurarTempList.length > 0) {
              if (this.objRestaurarTemp != null) {
                this.borrarTemporar();
              } else {
                this.alerta("Guardado corretamente!!!", "bien");
              }

            }
          }).catch((error) => {
            EventBus.$emit("loading", false);
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);

            } else if (error.request) {

              console.log(error.request);
            } else {
              console.log(error.message);
            }
            console.log(error.config);
          });

      } else {
        this.alerta("los campos en rojo son Requeridos", "error");
      }



    },
    llenarTemporal() {
      this.FacturaTemporal = {
        facturasProveedorestempPK: {
          documento: 0,
          codigo: 0,
        },
        empresa: this.FacturaProveedor.empresa,
        fecha: this.FacturaProveedor.fecha,
        referencia: this.FacturaProveedor.referencia,
        ordencompra: this.FacturaProveedor.ordencompra,
        diascredito: this.FacturaProveedor.diascredito,
        tipogasto: this.FacturaProveedor.tipogasto,
        ncf: "",
        totalimpuesto: this.FacturaProveedor.totalimpuesto,
        totaldescuento: this.FacturaProveedor.totaldescuento,
        total: this.FacturaProveedor.total,
        comentario: this.FacturaProveedor.comentario,
        tasa: this.FacturaProveedor.tasa,
        pendiente: this.FacturaProveedor.pendiente,
        activada: true,
        selectivo: this.FacturaProveedor.selectivo,
        itbisincluido: this.FacturaProveedor.itbisincluido,
        borrado: false,
        pendienteHacer: true,
        facturasProveedoresDetalletempList: [],
        documentoproveedor: this.FacturaProveedor.documentoproveedor,
        moneda: this.FacturaProveedor.moneda,
        proveedor: this.FacturaProveedor.proveedor,

      };
      this.ListProd.forEach((element) => {
        this.llenarDetalleTemporal(element);
      });
    },
    buscarFormato() {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/etiquetas/findall",
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.RlistFormato = res.data;
        });
    },
    cargarImpresoras() {
      this.$axios
        .get("http://localhost:15999/impresora/inicial/listaImpresora",
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.RlistImpresora = res.data[0].impresoras;
        });
    },
    llenarDetalleTemporal(datos) {
      if (datos.producto != null) {
        var detalle = {
          facturasProveedoresDetalletempPK: {
            codigo: 0,
            documento: this.FacturaProveedor.documentoproveedor.codigo,
            almacen: datos.almacen.codigo,
            unidad: datos.unidad.codigo,
            producto: datos.producto.codigo,
            oferta: datos.ofertaSelect,
          },
          // fechavencimiento: datos.fechavencimiento,
          fechavencimiento: datos.fechavencimiento != null ? datos.fechavencimiento + "T04:00" : null,
          cantidad: datos.cantidad,
          precio: datos.precio,
          descuento: datos.descuento,
          impuesto: datos.impuesto,
          valor: datos.valor,
          costo: datos.costo,
          precioFactura: datos.precio,
          descuentoPorciento: datos.descuentoPorciento,
          impuestoIncluido: this.FacturaProveedor.itbisincluido,
          borrado: false,
          almacenes: datos.almacen,
          productos: datos.producto,
          unidades: datos.unidad,
          loteFabricante: datos.hasOwnProperty('loteFabricante')?datos.loteFabricante:''
          //,id:datos.indx
        };
        this.FacturaTemporal.facturasProveedoresDetalletempList.push(detalle);
      }
    },
    importarDato() { },

    RestaurarTempDatostabla(e) {
      EventBus.$emit("loading", true);
      this.newwnuevo()
      var _this = this;
      setTimeout(function () {
        _this.contRestaurarTempDatostabla(e)
      }, 600);
    },

    contRestaurarTempDatostabla(e) {
      this.tipogasto = null
      this.RLisCuenta = []
      var Obj = JSON.parse(JSON.stringify(e))
      Obj.fecha = e.nuevaFecha
      this.objRestaurarTemp = JSON.parse(JSON.stringify(Obj))
      delete Obj["facturasProveedorestempPK"]
      delete Obj["facturasProveedoresDetalletempList"]
      //Obj.documentoproveedor=e.documentoproveedor
      //Obj.referencia=e.referencia
      Obj.facturasProveedoresPK = {
        codigo: 0,
        documento: 0
      }
      Obj.facturasProveedoresDetalleList = []
      if (e.facturasProveedoresDetalletempList != null && e.facturasProveedoresDetalletempList.length > 0) {

        var FactPro = JSON.parse(JSON.stringify(e.facturasProveedoresDetalletempList))

        var bar = new Promise((resolve, reject) => {

          FactPro.sort(function (a, b) {
            if (a.id > b.id) { return 1; }
            if (a.id < b.id) { return -1; }
            // a must be equal to b
            return 0;
          });

          resolve('resolved');
        });
        bar.then(() => { console.log('All done!'); });

        FactPro.forEach(element => {
          var varObj = JSON.parse(JSON.stringify(element))
          delete varObj["facturasProveedoresDetalletempPK"]
          varObj.facturasProveedoresDetallePK = JSON.parse(JSON.stringify(element.facturasProveedoresDetalletempPK))
          varObj.facturasProveedoresDetallePK.codigo = 0
          varObj.facturasProveedoresDetallePK.documento = 0
          Obj.facturasProveedoresDetalleList.push(varObj)
        });

      }
      var _this = this;
      setTimeout(function () {
        _this.calcularImpuesto()
        _this.datostabla(Obj);
        _this.dialogRestaurarTemporal = false;
      }, 500);

      if (e.tipogasto != null) {
        var ObjProRow = this.RTipoGasto.filter((ee) => ee.codigo == e.tipogasto);
        if (ObjProRow.length > 0) {
          this.tipogasto = JSON.parse(JSON.stringify(ObjProRow[0]))
        }
      }


      setTimeout(function () {
        _this.$refs.detalle.DisableCosto = false
      }, 1000);





      /*  this.FacturaProveedor = {
          facturasProveedoresPK: { codigo: 0, documento: 0 },
          empresa: null,
          fecha: fechaNueva(),
          referencia: e.referencia,
          ordencompra: e.ordencompra,
          diascredito: 0,
          tipogasto: e.tipogasto,
          tiposuplidor: null,
          ncf: e.ncf,
          totalimpuesto: e.totalimpuesto,
          totaldescuento: e.totaldescuento,
          total: e.total,
          comentario: e.comentario,
          tasa: e.tasa,
          pendiente: e.pendiente,
          activada: true,
          fechaCreacion: fechaNueva(),
          fechaModificacion: null,
          usuarioCreacion: "",
          usuarioModificacion: null,
          selectivo: e.selectivo,
          facturaGastos: false,
          itbisincluido: e.itbisincluido,
          pagosuspendido: false,
          comentarioSuspencion: "",
          descuentoIdividual: e.descuentoIdividual,
          borrado: false,
          detalleJson: "",
          documentoproveedor: e.documentoproveedor,
          moneda: e.moneda,
          proveedor: e.proveedor,
          facturasProveedoresDetalleList: [],
        };
        if (e.ncf != "") {
          // if (e.ncf.trim().length==19) {
          this.datosNCF.codigoFijo = e.ncf.substring(0, 3);
          this.datosNCF.secuencia = e.ncf.substring(3);
          //}
        }
        var detalle = [];
        this.$axios
          .get(
            this.$hostname +
              this.$hName +
              "/facturasproveedor/buscarTemporaldetalle/" +
              e.facturasProveedorestempPK.documento +
              "/" +
              e.facturasProveedorestempPK.codigo,
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
            res.data.forEach((element) => {
              this.$refs.detalle.addDetalleOrdenAFactura(element);
            });
          });*/
    },

    Restaurartem() {
      if (this.FacturaProveedor.proveedor == null) {
        this.alerta("Debe de seleccionar un proveedor.", "error");
        return;
      }
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/facturasproveedor/buscarTemporal/" +
          this.FacturaProveedor.proveedor.codigo,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.RestaurarTempList = res.data;
          this.dialogRestaurarTemporal = true;
        });

    },
    repetidosNoFactura(e) {
      if (this.FacturaProveedor.proveedor == null) {
        return;
      }
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/facturasproveedor/facturaUsada/" +
          this.FacturaProveedor.proveedor.codigo +
          "/" +
          e.target.value +
          "/0",
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          if (res.data) {
            this.alerta(
              "Esta factura Esta siendo usada por este proveedor !!!",
              "error"
            );
          }
        });
    },
    completarDigitos(e) {
      if (e.target.value != null) {
        var resultado = ("000000000" + e.target.value).substring(
          ("000000000" + e.target.value).length - 8,
          ("000000000" + e.target.value).length
        );
        this.datosNCF.secuencia = resultado;
      }
    },
    repetidosNcf() {
      if (this.FacturaProveedor.proveedor == null) {
        return;
      }
      if (this.datosNCF.codigoFijo == null) {
        return;
      }
      if (this.datosNCF.secuencia == null) {
        return;
      }

      var ncf =
        this.datosNCF.codigoFijo.trim() + this.datosNCF.secuencia.trim();
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/facturasproveedor/facturaUsada/" +
          this.FacturaProveedor.proveedor.codigo +
          "/0/" +
          ncf,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          if (res.data) {
            this.alerta(
              "Esta factura Esta siendo usada por este proveedor !!!",
              "error"
            );
          }
        });
    },
    vercuenta() {
      if (this.$refs.formFactPro.validate()) {
        //this.getCrearCont()
        if (this.RLisCuenta.length > 0) {
          this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta));
          this.TotalCuenta = JSON.parse(JSON.stringify(this.TotalCuenta));
          this.acti_Modal_cuenta = !this.acti_Modal_cuenta;
        } else {
          this.getCrearCont();
          this.acti_Modal_cuenta = !this.acti_Modal_cuenta;
        }
      } else {
        this.alerta("Los campos en rojo son requeridos", "error");
      }
    },
    getCrearCont() {
      //this.FacturaProveedor.total+this.TotalProd.descuento
      if (!this.$refs.formFactPro.validate()) {
      } else {
        if (this.configuraciones.config.multimoneda) {
          if (this.editCuentasC==false && this.FacturaProveedor.facturasProveedoresPK.codigo == 0) {
            EventBus.$emit("loading", true);
            this.$axios.get(this.$hostname +this.$hName +
                "/contabilidad/crear-contabilidad-cxp-multimoneda/" +
                this.FacturaProveedor.documentoproveedor.codigo +
                "/" +(this.FacturaProveedor.total) +"/" +this.TotalProd.impuesto +
                "/" +this.TotalProd.descuento +"/0/0/0/" +this.FacturaProveedor.moneda.codigo,
                { headers: this.$store.getters.GetheadersAxios }
              )
              .then((res) => {
                this.llenarcuenta(res.data);
                EventBus.$emit("loading", false);
              });
          }
        } else {
          if ( this.editCuentasC==false && this.FacturaProveedor.facturasProveedoresPK.codigo == 0) {
            EventBus.$emit("loading", true);
            this.$axios.get(this.$hostname + this.$hName +"/contabilidad/crear-contabilidad-cxp/" +
                this.FacturaProveedor.documentoproveedor.codigo +
                "/" +(this.FacturaProveedor.total) +
                "/" +this.TotalProd.impuesto +
                "/" +this.TotalProd.descuento +"/0/0",
                { headers: this.$store.getters.GetheadersAxios }
              )
              .then((res) => {
                this.llenarcuenta(res.data);
                EventBus.$emit("loading", false);
              });
          }
        }
        if (this.FacturaProveedor.facturasProveedoresPK.codigo != 0) {
          EventBus.$emit("loading", true);
          this.$axios
            .get(
              this.$hostname +
              this.$hName +
              "/contabilidad/findContabilidad/" +
              this.FacturaProveedor.facturasProveedoresPK.documento +
              "/" +
              this.FacturaProveedor.facturasProveedoresPK.codigo +
              "/" +
              this.FacturaProveedor.documentoproveedor.operacion.codigo,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
              this.llenarcuenta(res.data);
              EventBus.$emit("loading", false);
            });
        }
      }
    },
    llenarcuenta(e) {

      //
      if (typeof this.contabilidad !='object' || this.contabilidad === null ) {

         if (typeof e ==='object' && e!=null) {
        this.contabilidad = e;
        }else{
          this.contabilidad ={
              activo: true,
              borrado: false,
              comentario: "",
              contabilidadDetalleList: [],
              documento: this.FacturaProveedor.documentoproveedor.codigo,
              dsc: null,
              empresa: 0,
              entradaDiario: null,
              fecha: this.FacturaProveedor.fecha,
              id: null,
              operaciones:this.FacturaProveedor.documentoproveedor.operacion,
              referencia: ""
            }

        }

      }

if(e.contabilidadDetalleList!=null && typeof e.contabilidadDetalleList==='object' && e.contabilidadDetalleList.length>0){
var obj = JSON.parse(JSON.stringify(e.contabilidadDetalleList.filter((ee) => ee.cuenta!=null)));
  
  var _this = this;
        setTimeout(function () {
      _this.RLisCuenta = JSON.parse(JSON.stringify(obj));
      _this.objeTem = JSON.parse(JSON.stringify(_this.RLisCuenta));
      _this.calcularTotalcuenta(1)
        }, 500);

}

      /*if (this.contabilidad === null) {
        this.contabilidad = e;
        this.contabilidad.fecha = this.FacturaProveedor.fecha;
        this.contabilidad.documento =  this.FacturaProveedor.documentoproveedor.codigo;
      }

      this.RLisCuenta = JSON.parse(JSON.stringify(e.contabilidadDetalleList));
      this.RLisCuenta = this.RLisCuenta;
      this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta));
      this.calcularTotalcuenta(1);
      */
    },
    calcularTotalcuenta(e) {
      this.TotalCuenta.credito = 0;
      this.TotalCuenta.debito = 0;
      if (e.toString().length > 0) {
        this.RLisCuenta.forEach((element) => {
          this.TotalCuenta.credito += element.credito;
          this.TotalCuenta.debito += element.debito;
        });
      }
    },
    CCuentasContables(e, t, b) {
      if (e != undefined) {
        if (e.length == 0) {
          this.getCrearCont();
        } else {
          this.RLisCuenta = JSON.parse(JSON.stringify(e));
          this.TotalCuenta = JSON.parse(JSON.stringify(t));
        }
      }

      this.acti_Modal_cuenta = b;
      this.editCuentasC=true
    },

    VerFacturaProveedor() { },

    CargarRTipopago() {
      this.$axios
        .get(this.$hostname + this.$hName + "/categoriagastos/findallactivo", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.RTipoGasto = res.data;
        });
    },
    SelctCbTipoGasto() {
      if (this.tipogasto == null) {
        this.tipogasto = "";
      }
      if (this.tipogasto.codigo == undefined) {
        this.alerta("Seleccione un tipo gasto", "error");
        this.tipogasto = "";
        return;
      }
      this.FacturaProveedor.tipogasto = this.tipogasto.codigo;
    },

    cargarDocumento() {
      this.$axios.get(this.$hostname +this.$hName +"/documentoscxp/findAllDocumentosFacturasProveedores",
          { headers: this.$store.getters.GetheadersAxios }
        ).then((res) => (this.RDocumento = res.data));
    },

    SelctCbDocumento() {


      var _this = this;
      setTimeout(function () {
        if (_this.FacturaProveedor.documentoproveedor == null) {
          _this.FacturaProveedor.documentoproveedor = "";
        }

        if (!_this.FacturaProveedor.documentoproveedor.hasOwnProperty('codigo')) {
          _this.FacturaProveedor.documentoproveedor = "";
          _this.FacturaProveedor.documentoproveedor = null;
          return;
        }
      }, 300);


      /*FacturaProveedor.documentoproveedor
      if (this.FacturaProveedor.documentoproveedor == null) {
        this.FacturaProveedor.documentoproveedor = "";
      }
      if (this.FacturaProveedor.documentoproveedor.codigo == undefined) {
        this.alerta("Seleccione un documento", "error");
        this.FacturaProveedor.documentoproveedor = "";
        return;
      }*/
    },
    loadInfo() {
      this.configuraciones = this.$store.getters.GetConfiguracionGeneral;
      this.FacturaProveedor.moneda = this.configuraciones.config.monedabase;
      this.FacturaProveedor.tasa = this.configuraciones.config.monedabase.tasa;
      if (this.RTipoGasto.length <= 0) {
        this.CargarRTipopago();
      }
    },
    cargarOrdenCompra() {
      if (this.FacturaProveedor.proveedor == null) {
        return
      }
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/ordenescompras/proveedor/" +
          this.FacturaProveedor.proveedor.codigo,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.ProveedorOrdenCompra = res.data;
        });
    },
    CargarRalmacen() {
      this.$axios
        .get(this.$hostname + this.$hName + "/almacen",
          { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.Ralmacen = res.data;
        });
    },
    SelctCbAlmacen() {
      if (this.OrdenSugerida.almacen == null) {
        this.OrdenSugerida.almacen = "";
      }
      if (this.OrdenSugerida.almacen.codigo == undefined) {
        this.alerta("Seleccione un Almacén", "error");
        this.OrdenSugerida.almacen = "";
        return;
      }
    },

    SelctCbAlmacenTb() {

      // console.log(this.$refs.refTabla.ActualizarAlmacenEnTabla)

      var _this = this;
      setTimeout(function () {
        if (_this.almacen == null) {
          _this.almacen = "";
        }

        if (!_this.almacen.hasOwnProperty('codigo')) {
          _this.almacen = "";
          //_this.almacen= null;
          _this.findAlmacenPrincipal()
          //  _this.alerta("Seleccione un cliente", "error");
          return;
        }

        _this.$refs.detalle.ActualizarAlmacenEnTabla()

      }, 300);

    },



    ChangeAlmacen(e) {

      // if (e != null) {
      //   this.ActualizaAlmacen = true
      // }

    },



    keyupDiaOrden() {
      if (e.key) {
        var mynumeral = require("numeral");
        this.OrdenSugerida.dia = mynumeral(this.OrdenSugerida.dia).value();
        if (this.OrdenSugerida.dia == null) {
          this.OrdenSugerida.dia = 0;
        }
      } else {
        console.log("no se puede poner letras o signos");
      }
    },

    addClikProd() { },
    borrarTemporar() {

      // if (this.RestaurarTempList.length > 0) {

      if (this.objRestaurarTemp != null) {
        this.$axios
          .post(this.$hostname + this.$hName + "/facturasproveedor/anularTemporal", this.objRestaurarTemp, {
            // .post(this.$hostname + this.$hName + "/facturasproveedor/anularTemporal", this.RestaurarTempList[0], {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Guardado corretamente!!!", "bien");;
          });
      }
    },
    newCrearProducto() { },

    save() {
      if (!this.asegurarRevisionConfirmadaFacturaIa())
        return;
      if (this.FacturaProveedor.facturasProveedoresPK.codigo > 0) {
        if (this.EjecutarPermisoPv == false) {
          this.ObjEjecPermisoPv = JSON.parse(JSON.stringify(this.FacturaProveedor))
          this.funcionValidaPermisoPv('AccModificarRegFacPro')
          return;
        }
      } else {
        this.saveCont()
      }
    },

    saveCont() {
      if (!this.asegurarRevisionConfirmadaFacturaIa())
        return;
      if (this.$refs.formFactPro.validate()) {

        if (this.FacturaProveedor.diascredito == null || this.FacturaProveedor.diascredito == 0) {
          if (this.FacturaProveedor.diascredito == null) { this.FacturaProveedor.diascredito = 0 }
          var notif = {
            estado: true,
            nombre: "¿Esta Factura tiene 0 días de crédito(PLAZO). Desea salvarla??",
            Exec: "SaveContFactPro",
          };
          this.Exec_notif(notif);

        } else {
          this.saveReg()
        }

      } else {
        if (this.$refs.secuenciaRef.validations.includes("Maximo 20 caracteres")){
          this.alerta("El NCF debe tener maximo 20 caracteres", "error");
        }else {
          this.alerta("Los campos en rojo son requeridos", "error");
        }
      }
    },

    async saveReg() {
      if (!this.asegurarRevisionConfirmadaFacturaIa())
        return;

      //  this.getCrearCont();
      var tot = Math.round(this.FacturaProveedor.total * 100) / 100;
      var imp = Math.round(this.TotalProd.importe * 100) / 100;


      if (this.datosNCF.codigoFijo.trim().length > 0 && this.datosNCF.secuencia.trim().length <= 0) {
        this.alerta("Debe de completar el NCF ya que solo tiene seleccionado el prefijo", "error");
        return;
      }

      var CONTROLAR_TOTAL = true
      if (this.configuraciones.configCxp.hasOwnProperty('noControlarFactura') && this.configuraciones.configCxp.noControlarFactura == true) {
        CONTROLAR_TOTAL = false
      }
      if (CONTROLAR_TOTAL == true) {
        // if (tot != imp) 
        if(this.RedondeoValorCantRed(tot,2)!=this.RedondeoValorCantRed(imp,2)){

          if(this.RedondeoValorCantRed((tot - imp),2)!=0){
            if (this.RedondeoValorCantRed((tot - imp),2) > 0.01 || this.RedondeoValorCantRed((tot - imp),2) < -0.01) {
          this.alerta(
            "El valor de la factura debe ser igual al total de los productos",
            "error"
          );
          return;
            }
          }
        }
        

      }
      if (this.$refs.formFactPro.validate()) {

        if (this.FacturaProveedor.tasa == null || this.FacturaProveedor.tasa == 0) {
          this.alerta(" La tasa de la moneda no puede estar vacio o ser cero","error");
          return
        }
        var productosIaSinRelacion = this.ListProd.filter((detalle) =>
          detalle.esDetalleIa === true
          && (!detalle.producto || !detalle.producto.codigo || !detalle.unidad || !detalle.unidad.codigo)
        );
        if (productosIaSinRelacion.length > 0) {
          this.alerta(
            "Debe seleccionar manualmente el producto y la unidad de todas las líneas analizadas antes de guardar.",
            "error"
          );
          return;
        }
        if (this.ejecucion == true) {
          EventBus.$emit("loading", true);
          this.ejecucion = false;
          var list_pro = this.ListProd.filter(
            d => d.producto != null && d.producto.codigo && d.unidad != null && d.unidad.codigo
          );

          this.FacturaProveedor.facturasProveedoresDetalleList = [];
          var productosVenciemitno = list_pro.filter(det => det.fechavencimiento !== null).length;
          var productosParaVencieminto = list_pro.filter(d => d.producto.controlVencimiento == true).length;

          if (this.tipogasto != null) { this.FacturaProveedor.tipogasto = this.tipogasto.codigo }
          if (this.FacturaProveedor.facturasProveedoresPK.codigo == 0) {
            if (productosVenciemitno != productosParaVencieminto) {
              // console.log('hola Mundo', list_pro.filter(d => d.producto.controlVencimiento == true && d.fechavencimiento == null || d.fechavencimiento != null && d.fechavencimiento.trim().length == 0))
              var OBJLIST = list_pro.filter(d => d.producto.controlVencimiento == true && d.fechavencimiento == null || d.fechavencimiento != null && d.fechavencimiento.trim().length == 0);
              var DESCPRO = ""
              if (OBJLIST.length > 0) { DESCPRO = OBJLIST[0].propsDesProdUnid.trim() }

              this.alerta(`Debe verificar los productos ya que existen productos que debe llevar fecha de vencimiento!!! \n (${DESCPRO})`, "error")     
              return
            }
          }

          /* list_pro.forEach((e) => {
             this.llenarDetalle(e);
           });*/

          await Promise.all(
            list_pro.map(async (e) => {
              this.llenarDetalle(e);
            })
          );

          /*  this.FacturaProveedor.contabilidad = this.contabilidad;
            this.FacturaProveedor.cont = this.contabilidad;*/
          this.FacturaProveedor.ncf = this.datosNCF.codigoFijo.trim() + this.datosNCF.secuencia.trim();

          if (this.ListProd.filter((e) => e.cantidad > 0 && e.producto != null).length <= 0) {
            this.alerta(
              "Debe seleccionar almeno un producto para registrar una factura",
              "error"
            );
            return;
          }

          if (list_pro.filter(det => det.fechavencimiento != null && det.fechavencimiento.length > 10).length > 0) {
            this.alerta(
              "Fecha de vencimiento erroneas, revisar las fechas de vencimiento.",
              "error"
            );
            list_pro.filter(det => det.fechavencimiento != null && det.fechavencimiento.length > 10).forEach(element => {
              console.log(element.producto.descripcion + " - " + element.unidad.descripcion);
            });
            return;
          }


          var Objduplicado={
            duplicado:false,
            objList:null
          }

          await Promise.all( this.FacturaProveedor.facturasProveedoresDetalleList.map(async (e) => {
              var ObjProRow = this.FacturaProveedor.facturasProveedoresDetalleList.filter((ee) => 
              ee.facturasProveedoresDetallePK.producto===e.facturasProveedoresDetallePK.producto &&
            ee.facturasProveedoresDetallePK.unidad===e.facturasProveedoresDetallePK.unidad &&
            ee.facturasProveedoresDetallePK.oferta===e.facturasProveedoresDetallePK.oferta &&
            ee.fechavencimiento===e.fechavencimiento
              );

              if(ObjProRow.length>1){
                 Objduplicado.duplicado=true
                 Objduplicado.objList=ObjProRow
              }
            
          }));


          if(Objduplicado.duplicado==true){
            var DESCPRO = Objduplicado.objList[0].productos.descripcion.trim()
            var DESCUNI =  Objduplicado.objList[0].unidades.descripcion.trim()
            var FECVEN =  Objduplicado.objList[0].fechavencimiento !=null ? ` FECHA V. ${Objduplicado.objList[0].fechavencimiento}` : ``
            var OFPRO =  Objduplicado.objList[0].facturasProveedoresDetallePK.oferta ==true ? ` **OFERTA** :` : ``

          var _this = this;
        setTimeout(function () {
           /*EventBus.$emit("loading", false);
          _this.ejecucion = true;*/
           _this.alerta(`Debe verificar los productos ya que existen productos que esta duplicado!!! \n (${OFPRO} ${DESCPRO} (${DESCUNI}). ${FECVEN} )`, "error") 
        }, 1000);
        return;
          // this.ejecucion = false;
            // this.alerta(`Debe verificar los productos ya que existen productos que esta duplicado!!! \n (${OFPRO} ${DESCPRO} (${DESCUNI}). ${FECVEN} )`, "error")
            // return;
          }

       
            // await Promise.all( list_pro.map(async (e) => {
            //   var ObjProRow = list_pro.filter((ee) => ee.codigo == e.tipogasto);
            // }));


         
  
          this.FacturaProveedor.cont = this.contabilidad
          if(this.FacturaProveedor.cont===null){
            this.FacturaProveedor.cont ={
              activo: true,
              borrado: false,
              comentario: "",
              contabilidadDetalleList: [],
              documento: this.FacturaProveedor.documentoproveedor.codigo,
              dsc: null,
              empresa: 0,
              entradaDiario: null,
              fecha: this.FacturaProveedor.fecha,
              id: null,
              operaciones:this.FacturaProveedor.documentoproveedor.operacion,
              referencia: ""
            }
          }

          if(this.RLisCuenta.length>0){
        this.FacturaProveedor.cont.contabilidadDetalleList=this.RLisCuenta
        }else{this.FacturaProveedor.cont.contabilidadDetalleList=[] }

          /*var oobj=this.FacturaProveedor
          oobj.facturasProveedoresDetalleList=this.objobj
          console.log(oobj)*/
          this.FacturaProveedor.totaldescuento = this.RedondeoBasico(this.$refs.detalle.TotalProd.descuento)
          this.FacturaProveedor.totalimpuesto = this.RedondeoBasico(this.$refs.detalle.TotalProd.impuesto)

          this.FacturaProveedor.listFoto = this.listObjFoto;
          //trabajando aqui


          var FAC_PROV= this.FacturaProveedor

          if (this.FacturaProveedor.facturasProveedoresPK.codigo  == 0) {
            FAC_PROV.usuarioCreacion = this.$store.getters.GetdatosInfUsu.usuario.usuario
            FAC_PROV.fechaCreacion = this.fechaNueva() + "T04:00"
          } else {
            FAC_PROV.usuarioModificacion = this.$store.getters.GetdatosInfUsu.usuario.usuario
            FAC_PROV.fechaModificacion = this.fechaNueva() + "T04:00"
          }
          FAC_PROV.fecha=FAC_PROV.fecha.trim().substr(0, 10) + "T04:00"

          this.$axios
            .post(
              this.$hostname + this.$hName + "/facturasproveedor/salvar",
              FAC_PROV,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {

              var cod = this.FacturaProveedor.facturasProveedoresPK.codigo

              // if (this.RestaurarTempList.length > 0) {
              if (this.objRestaurarTemp != null) {
                this.borrarTemporar();
              } else {
                this.alerta("Dato guardado correctamente", "bien")
              }

              if (cod == 0) {
                var _this = this;
                setTimeout(function () {
                  _this.datostabla(res.data)
                  // _this.MethodReimprimirEtiqueta()
                 // _this.dialogImprimirEtiqueta = true
                }, 500);

                setTimeout(function () {
                  _this.MethodReimprimirEtiqueta()
                 // _this.dialogImprimirEtiqueta = true

                }, 999);



              }
            })
            .catch((error) => {
              if (error.response) {
                this.alerta(error.response.data, "error")
              } else if (error.request) {
                this.alerta(error.request, "error")
              } else {
                this.alerta(error.message, "error")
              }
            });
        }
      } else {
        this.alerta("los campos en rojo son Requeridos", "error");
      }
    },
    llenarDetalle(datos) {
      var detalle = {
        facturasProveedoresDetallePK: {
          codigo: 0,
          documento: this.FacturaProveedor.documentoproveedor.codigo,
          unidad: datos.unidad.codigo,
          producto: datos.producto.codigo,
          oferta: datos.ofertaSelect,
        },
        //fechavencimiento: datos.fechavencimiento,
        fechavencimiento: datos.fechavencimiento != null ? datos.fechavencimiento + "T04:00" : null,
        cantidad: datos.cantidad,
        precio: datos.precio,
        descuento: datos.descuento,
        impuesto: datos.impuesto,
        valor: RedondeoBasico(datos.valor),
        costo: datos.costo,
        //precioFactura: datos.precio,
        precioFactura: datos.precio2,
        impuestoIncluido: false,
        descuentoPorciento: false,
        borrado: false,
        almacen: datos.almacen,
        productos: datos.producto,
        unidades: datos.unidad,
        descuentoPorciento: datos.descuentoPorciento,
        loteFabricante: datos.hasOwnProperty('loteFabricante')?datos.loteFabricante:''
      };
      this.FacturaProveedor.facturasProveedoresDetalleList.push(detalle);
    },
    NotifMessage() {
      if (
        this.FacturaProveedor.facturasProveedoresPK.codigo != 0 &&
        this.FacturaProveedor.facturasProveedoresPK.codigo != null
      ) {
        var notif = {
          estado: true,
          nombre: "¿Seguro que desea anular este registro?",
          Exec: "AnularFactPro",
        };
        this.Exec_notif(notif);
      } else {
        this.alerta("Seleccione una factura proveedor para anular", "error");
      }
    },
    Exec_notif(e) {
      this.notif = JSON.parse(JSON.stringify(e));
    },
    eliminar() { },


    anular(){
      if (this.EjecutarPermisoPv == false) {
          this.ObjEjecPermisoPv = JSON.parse(JSON.stringify(this.FacturaProveedor))
          this.funcionValidaPermisoPv('AccAnularRegistroProveedores')
          return;
        }
    },



    contAnulacion() {

      if (
        this.FacturaProveedor.facturasProveedoresPK.codigo != 0 &&
        this.FacturaProveedor.facturasProveedoresPK.codigo != null
      ) {
        if (this.$refs.formFactPro.validate()) {
          EventBus.$emit("loading", true);
          var linkverificar = `/${this.FacturaProveedor.facturasProveedoresPK.codigo}/${this.FacturaProveedor.facturasProveedoresPK.documento}/1`
          this.$axios.get(
            this.$hostname + this.$hName + "/pagoproveedores/VerificarMovimientoPago" + linkverificar,
            { headers: this.$store.getters.GetheadersAxios }
          )
            .then((res) => {
              if (res.data == true) {
                this.alerta("Dato no anulado correctamente, esta factura posee pago", "error")
              } else {
                this.VerificarMovimNotDebito(linkverificar)

              }

            })
            .catch((error) => this.alerta(error, "error"));






        }
      }
    },





    VerificarMovimNotDebito(Links) {
      this.$axios.get(
        this.$hostname + this.$hName + "/notadebitoproveedores/VerificarMovimientoNotaDebito" + Links,
        { headers: this.$store.getters.GetheadersAxios }
      )
        .then((res) => {
          if (res.data == true) {
            this.alerta("Dato no anulado correctamente, esta factura posee Nota de debito", "error")
          } else {
            this.VerificarMovimCheque(Links)
          }

        })
        .catch((error) => this.alerta(error, "error"));

    },


    VerificarMovimCheque(Links) {
      this.$axios.get(
        this.$hostname + this.$hName + "/cheques/VerificarMovimientoCheque" + Links,
        { headers: this.$store.getters.GetheadersAxios }
      )
        .then((res) => {
          if (res.data == true) {
            this.alerta("Dato no anulado correctamente, esta factura posee Cheque", "error")
          } else {
            this.ContAnular()
          }

        })
        .catch((error) => this.alerta(error, "error"));

    },




    ContAnular() {
      this.$axios
        .post(
          this.$hostname + this.$hName + "/facturasproveedor/anular",
          this.FacturaProveedor,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.alerta("La factura fue anulada correctamente !!!", "bien");
        })
        .catch((error) => {
          let msg = "";
          if (error.response) {
            msg = error.response.data
          } else if (error.request) {
            msg = error.request.data
          } else {
            msg = error.message;
          }
          this.alerta("Dato no anulado" + ": " + msg, "error")

        }

          // EventBus.$emit("loading", false)
        );
    },

    imprimirList() {
      if (this.FacturaProveedor.facturasProveedoresPK.codigo > 0) {
        this.datosImprecion.codigo =
          this.FacturaProveedor.facturasProveedoresPK.codigo;
        this.datosImprecion.documento =
          this.FacturaProveedor.facturasProveedoresPK.documento;
        this.datosImprecion.orden = this.FacturaProveedor.ordencompra;
        this.dialogimprimirList = true;
      } else {
        this.alerta("Seleccione un Producto para poder imprimir", "error");
      }
    },

    ImprimirEtiqueta() {
      if(this.$store.getters.GetConfiguracionGeneral.configCxp.hasOwnProperty('cambiarCantidadEtiqueta') && this.configuraciones.configCxp.cambiarCantidadEtiqueta  == true){
      var FACT_PROVE=JSON.parse(JSON.stringify(this.FacturaProveedor))
      FACT_PROVE.facturasProveedoresDetalleList=this.listaProducImprir
      this.ImprimirItemEtiquetaFActura(FACT_PROVE);
    } else{
          this.ImprimirItemEtiquetaFActura(this.FacturaProveedor);
       }
      
    },


    async ImprimirItemEtiquetaFActura(e) {


EventBus.$emit("loading", true);
if(this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==true){

var LIST = e.facturasProveedoresDetalleList.filter((ee) => ee.productos.imprimirEtiqueta == true && !ee.productos.hasOwnProperty('tipoFactura') || ee.productos.hasOwnProperty('tipoFactura') && ee.productos.tipoFactura==null)

  if(LIST.length>0){
    this.alerta(`NOTA: EL PRODUCTO: ${LIST[0].productos.descripcion} ${LIST[0].unidades.descripcion}  NO TIENE ASIGNADO TIPO DE FACTURA  `, "error")
    return
  }
this.ImprimirItemEtiquetaFActuraDistFarmaceutico(e)
}else{
  this.ImprimirItemEtiquetaFActuraPordefecto(e)
}
      

      


    },

ImprimirItemEtiquetaFActuraDistFarmaceutico(e){

  var OBJDATA = {
        distribuidoraFarmaceutico: this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico,
        usarLote: this.$store.getters.GetConfiguracionGeneral.configInv.usarLote,
        config: this.$store.getters.GetConfiguracionGeneral,
        suplidor: e.proveedor,
        factura: e.referencia,
        formatoBarra: this.ImprirEtiqueta.ImpesoraBarra,
        Impresora: this.ImprirEtiqueta.selectImpresora,
        configInvUsarLote: this.$store.getters.GetConfiguracionGeneral.configInv.usarLote,
        lista: e.facturasProveedoresDetalleList.filter((ee) => ee.productos.imprimirEtiqueta == true)
       }

      this.$axios.post(this.$hostname + this.$hName + "/facturasproveedor/objectoEtiquetaListaDistFarmaceutico",
        OBJDATA, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          //this.contImprimiendo(res.data)
          var ListaEtiqueta = {
           ListaEtiqueta: res.data
             }
           this.imprimir(ListaEtiqueta, "etiquetaListDistFarmaceutico")
        })
        .catch((error) => {
          EventBus.$emit("loading", false);
          /* this.loading(false)*/
          this.alerta("Dato no Impreso", "error")
        }
        );

},

ImprimirItemEtiquetaFActuraPordefecto(e){

  var OBJDATA = {
        usarLote: this.$store.getters.GetConfiguracionGeneral.configInv.usarLote,
        config: this.$store.getters.GetConfiguracionGeneral,
        suplidor: e.proveedor,
        factura: e.referencia,
        formatoBarra: this.ImprirEtiqueta.ImpesoraBarra,
        Impresora: this.ImprirEtiqueta.selectImpresora,
        configInvUsarLote: this.$store.getters.GetConfiguracionGeneral.configInv.usarLote,
        lista: e.facturasProveedoresDetalleList.filter((ee) => ee.productos.imprimirEtiqueta == true)

      }
      
      this.$axios.post(this.$hostname + this.$hName + "/facturasproveedor/objectoEtiquetaLista",
        OBJDATA, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.contImprimiendo(res.data)
        })
        .catch((error) => {
          EventBus.$emit("loading", false);
          /* this.loading(false)*/
          this.alerta("Dato no Impreso", "error")
        }
        );

},






    async ImprimirItemEtiquetaFActura2(e) {
      if (e != null) {

        var LISTA_COMPR = []

        await Promise.all(e.facturasProveedoresDetalleList.map(async (element) => {
          if (element.productos.imprimirEtiqueta) {
            this.$axios
              .get(
                this.$hostname + this.$hName + "/unidades-productos/find/" + element.productos.codigo + "/" + element.unidades.codigo,
                { headers: this.$store.getters.GetheadersAxios }
              )
              .then((res) => {
                var UNI_MINI = null
                var bar = new Promise((resolve, reject) => {
                  if (res.data.unidadminima == false) {
                    this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/findUnidadMinimaCompra/" + element.productos.codigo + "/true",
                      { headers: this.$store.getters.GetheadersAxios })
                      .then((ress) => {
                        UNI_MINI = ress.data
                        resolve()
                      });

                  } else {
                    UNI_MINI = res.data
                    resolve()
                  }
                });

                bar.then(() => {
                  console.log('All done!');
                  if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {

                    this.$axios
                      .get(
                        this.$hostname + this.$hName + "/unidades-productos/getLote/" + res.data.fechavencimiento,
                        { headers: this.$store.getters.GetheadersAxios }
                      )
                      .then((lote) => {
                        var resultado = {};
                        resultado.config = this.$store.getters.GetConfiguracionGeneral;
                        resultado.suplidor = e.proveedor;
                        resultado.cantidad = element.cantidad;
                        resultado.producto = res.data;
                        resultado.producto.lote = lote.data;
                        resultado.factura = e.referencia;
                        resultado.unidad = element.unidades.descripcion;
                        resultado.formatoBarra = this.ImprirEtiqueta.ImpesoraBarra;
                        resultado.Impresora = this.ImprirEtiqueta.selectImpresora;
                        resultado.productoOpuesto = UNI_MINI;
                        resultado.orden = element.orden
                        //this.imprimir(resultado, "etiqueta");
                        LISTA_COMPR.push(resultado)
                      });
                  } else {
                    var resultado = {};
                    resultado.config = this.$store.getters.GetConfiguracionGeneral;
                    resultado.suplidor = e.proveedor;
                    resultado.cantidad = element.cantidad;
                    resultado.producto = res.data;
                    resultado.factura = e.referencia;
                    resultado.unidad = element.unidades.descripcion;
                    resultado.formatoBarra = this.ImprirEtiqueta.ImpesoraBarra;
                    resultado.Impresora = this.ImprirEtiqueta.selectImpresora;
                    resultado.productoOpuesto = UNI_MINI;
                    resultado.orden = element.orden
                    if (element.fechavencimiento != null) {
                      resultado.fecha = this.getParamFecha(element.fechavencimiento)
                    }
                    //this.imprimir(resultado, "etiqueta");
                    LISTA_COMPR.push(resultado)
                  }

                });

              });
          }


        }));


        var _this = this;
        setTimeout(function () {
          LISTA_COMPR.sort(function (a, b) {
            if (a.orden < b.orden) { return -1; }
            if (a.orden > b.orden) { return 1; }
            // a must be equal to b
            return 0;
          });
          _this.contImprimiendo(LISTA_COMPR)
        }, 1000);

      }


    },


    async contImprimiendo(LISTA_COMPR) {
      //this.imprimir(resultado, "etiqueta");
      // console.log('listaProducto-->',LISTA_COMPR)

      //etiquetaList
      var ListaEtiqueta = {
        ListaEtiqueta: LISTA_COMPR
      }
      this.imprimir(ListaEtiqueta, "etiquetaList")

      /*await Promise.all(LISTA_COMPR.map(async (element) => {
        var _this=this;
       setTimeout(function(){ 
        //etiqueta
                      _this.imprimir(element, "etiqueta");
         }, 1000);
      
                }));*/


    },


    imprimir(datos, operacion) {
      EventBus.$emit("loading", true);
      datos.operacion = operacion;
      this.$axios
        .post("http://localhost:15999/impresora/imprimir", datos)
        .then((res) => {
          EventBus.$emit("loading", false);
          //this.limpiarPuntoVentaCompleto();
        })
        .catch((error) => {
          EventBus.$emit("loading", false);
          console.error(error)
        });

    },
    DDataReporteBasico(e) {
      this.dialogimprimirList = e;
    },

    OpendialogimprimirListFilt() {
      this.dialogimprimirListFilt = true;
      var _this = this;
      setTimeout(function () {
        _this.$refs.ModRepfil.CrearObjecto = _this.validarObjecto;
      }, 300);
    },

    validarObjecto() {
      //this.datosImprecionAll.tenant=this.datosImprecion.schema=this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      var where =
        "facturas_proveedores.proveedor = proveedores.codigo AND facturas_proveedores.documento = documentoproveedor.codigo";
      this.datosImprecionAll.documento = "";
      if (this.datosImprecionAll.FecRegi == true) {
        where += ` and date_trunc('day',facturas_proveedores.fecha_creacion)>= ' ${new Date(
          this.datosImprecionAll.desde
        )
          .toISOString()
          .substr(
            0,
            10
          )}' and date_trunc('day',facturas_proveedores.fecha_creacion) <= ' ${new Date(
            this.datosImprecionAll.hasta
          )
            .toISOString()
            .substr(0, 10)} ' `;
      } else {
        where += ` and facturas_proveedores.fecha>= ' ${new Date(
          this.datosImprecionAll.desde
        )
          .toISOString()
          .substr(0, 10)}' and facturas_proveedores.fecha <= ' ${new Date(
            this.datosImprecionAll.hasta
          )
            .toISOString()
            .substr(0, 10)} ' `;
      }

      if (this.datosImprecionAll.documentos != null) {
        where += ` and facturas_proveedores.documento= ${this.datosImprecionAll.documentos.codigo}`;
        this.datosImprecionAll.documento =
          this.datosImprecionAll.documentos.descripcion;
      }
      this.datosImprecionAll.where = where;
    },

    calcularImpuesto() {
      this.$refs.detalle.setImpuestoIncluido(
        this.FacturaProveedor.itbisincluido
      );
    },
    calcularDescuentoIndividual() {
      this.$refs.detalle.setDescuentoIndividual(
        this.FacturaProveedor.descuentoIdividual
      );
    },

    newwnuevo() {

      this.findAlmacenPrincipal()
      if (this.modoIa) {
        this.liberarVistaPreviaFacturaIa();
        this.limpiarResultadoIa();
      }

      this.contabilidad = null
      this.RLisCuenta = []
      this.editCuentasC=false
      this.tipogasto = null
      this.ListProd = []
      this.$refs.detalle.DisableCosto = false
      this.BarraTablaDinamicaAprir = false;
      this.FacturaTemporal = null;
      this.RestaurarTempList = []
      this.objRestaurarTemp = null
      this.listaProducImprir=[]
      this.FacturaProveedor = {
        facturasProveedoresPK: { codigo: 0, documento: 0 },
        empresa: null,
        fecha: fechaNueva(),
        referencia: "",
        ordencompra: null,
        diascredito: 0,
        tipogasto: 0,
        tiposuplidor: null,
        ncf: "",
        totalimpuesto: 0,
        totaldescuento: 0,
        total: 0.0,
        comentario: null,
        tasa: 0,
        pendiente: 0.0,
        activada: true,
        fechaCreacion: fechaNueva(),
        fechaModificacion: null,
        usuarioCreacion: "",
        usuarioModificacion: null,
        selectivo: 0.0,
        facturaGastos: false,
        itbisincluido: false,
        pagosuspendido: false,
        comentarioSuspencion: "",
        descuentoIdividual: 0,
        borrado: false,
        detalleJson: "",
        documentoproveedor: "",
        moneda: null,
        proveedor: null,
        facturasProveedoresDetalleList: [],
        totaldescuento: 0,
        totalimpuesto: 0,
        listFoto: []
      };
      this.datosNCF = {
        codigoFijo: "",
        secuencia: "",
      };
      this.TotalProd = {
        cantidad: 0,
        cantExit: 0,
        costo: 0,
        subtotal: 0,
        impuesto: 0,
        descuento: 0,
        importe: 0,
      };


      this.newImagen()
      this.listObjFoto = []
      this.ejecucion = true;
      EventBus.$emit("loading", false);
      EventBus.$emit("actualizaBarraBusqueda2");

      var _this = this;
      setTimeout(function () {
        _this.ListProd = []
        _this.$refs.detalle.totalesNuevo()
      }, 300);

      this.loadInfo()

    },
    async datostabla(e) {
      EventBus.$emit("loading", true);
      this.getCargerImagen(e.facturasProveedoresPK.codigo, e.facturasProveedoresPK.documento)
      //this.ejecucion = true;
      /* if(this.FacturaProveedor.facturasProveedoresPK.codigo==e.facturasProveedoresPK.codigo){
         return
       }*/
      // this.FacturaProveedor = JSON.parse(JSON.stringify(e));
      this.contabilidad = null
      this.RLisCuenta = []
      this.ListProd = [];
      this.datosNCF.codigoFijo = ""
      this.datosNCF.secuencia = ""

      if (e.ncf != null) {
        if (e.ncf.trim().length == 11) {
          this.datosNCF.codigoFijo = e.ncf.trim().substr(0, 3);
          this.datosNCF.secuencia = e.ncf.trim().substr(3);
        }

        if (e.ncf.trim().length == 13) {
          this.datosNCF.codigoFijo = e.ncf.trim().substr(0, 5);
          this.datosNCF.secuencia = e.ncf.trim().substr(5);
        }
        if (e.ncf.trim().length >= 19) {
          this.datosNCF.codigoFijo = e.ncf.trim().substr(0, 11);
          this.datosNCF.secuencia = e.ncf.trim().substr(11);
        }
      }

      this.tipogasto = this.RTipoGasto.filter(t => t.codigo == e.tipogasto)[0]
      if (e.moneda == null) {
        this.loadInfo()
      }

      var obj = JSON.parse(JSON.stringify(e))
      obj.total=(obj.total/obj.tasa)
      obj.fecha = e.nuevaFecha

      if (!e.hasOwnProperty('descuentoIdividual')) { obj.descuentoIdividual = 0 }
      if (e.hasOwnProperty('descuentoIdividual') && e.descuentoIdividual == null) { obj.descuentoIdividual = 0 }
      this.acti_tb_data = false;

      if (obj.facturasProveedoresDetalleList.length > 0) {
//a.orden
        
        obj.facturasProveedoresDetalleList.sort(function (a, b) {
          if (a.facturasProveedoresDetallePK.codid < b.facturasProveedoresDetallePK.codid) { return -1; }
          if (a.facturasProveedoresDetallePK.codid > b.facturasProveedoresDetallePK.codid) { return 1; }
          // a must be equal to b
          return 0;
        });


        if (obj.facturasProveedoresDetalleList[0].hasOwnProperty('almacen')) {
          this.almacen = JSON.parse(JSON.stringify(obj.facturasProveedoresDetalleList[0].almacen))
        }
        if (obj.facturasProveedoresDetalleList[0].hasOwnProperty('almacenes')) {
          this.almacen = JSON.parse(JSON.stringify(obj.facturasProveedoresDetalleList[0].almacenes))
        }

      }




      /*obj.facturasProveedoresDetalleList.forEach(element => {
        element.ofertaSelect=element.facturasProveedoresDetallePK.oferta  
      });*/
    
      await Promise.all(obj.facturasProveedoresDetalleList.map(async (element) => {
        element.ofertaSelect = element.facturasProveedoresDetallePK.oferta
      }));

       
      var _this = this;
      setTimeout(function () {
        _this.ListProd = [];
        _this.$refs.detalle.totalesNuevo()
      }, 200);
      setTimeout(function () {
        _this.llenarObjeto(obj);
      }, 300);

      setTimeout(function () {
        _this.getCrearCont()
      }, 900);



    },
    async llenarObjeto(e) {
      var FAC_PROV=JSON.parse(JSON.stringify(e));
      
      FAC_PROV.total=(FAC_PROV.total/FAC_PROV.tasa)
      FAC_PROV.totalimpuesto=(FAC_PROV.totalimpuesto/FAC_PROV.tasa)


      this.FacturaProveedor = JSON.parse(JSON.stringify(FAC_PROV));
      this.FacturaProveedor.fecha = new Date(e.fecha).toISOString().substr(0, 10);

      if (e.facturasProveedoresDetalleList.length > 0) {

        // e.facturasProveedoresDetalleList.forEach((el) => { });
        Promise.all(e.facturasProveedoresDetalleList.map(async (el) => {
          var det = {
            facturasProveedoresDetallePK: {
              codigo: el.codigo,
              documento: el.documento,
              unidad: el.unidad,
              producto: el.producto,
              oferta: el.oferta,
            },
            ofertaSelect: el.ofertaSelect,
            // ofertaSelect:JSON.parse(JSON.stringify(el.oferta)),
            // fechavencimiento: el.fechavencimiento != null ? new Date(el.fechavencimiento).toISOString().substr(0, 10) : null,
            fechavencimiento: el.nuevaFechaVencimiento,
            //  fechavencimiento: el.fechavencimiento != null ? (new Date(el.fechavencimiento)).toJSON().split("T")[0] : null,
            cantidad: el.cantidad,
            precio: (el.precio/e.tasa),
            descuento: (el.descuento/e.tasa),
            impuesto: (el.impuesto/e.tasa),
            valor: (el.valor/e.tasa),
            costo: (el.costo/e.tasa),
            precioFactura: (el.precioFactura/e.tasa),
            impuestoIncluido: el.impuestoIncluido,
            descuentoPorciento: el.descuentoPorciento,
            borrado: false,
            almacen: el.almacen,
            producto: el.productos,
            unidad: el.unidades,
            loteFabricante: el.hasOwnProperty('loteFabricante')?el.loteFabricante:''

          };

          if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
            det.lote = el.lote
          }

          // this.$refs.detalle.addDetalleOrdenAFactura(det);
          this.$refs.detalle.addDetalledatostablaFacProveedor(det)

        }));

        var _this = this;
        setTimeout(function () {
          _this.calcularDescuentoIndividual()
          EventBus.$emit("loading", false);
          // _this.$refs.detalle.calcularTotales();
        }, 900);

      }

      this.$refs.detalle.DisableCosto = true
      return;
    },
    cargarProveedor() {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/proveedores/findallbyDesc/25/0/a",
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => (this.Rproveedor = res.data));
    },

    SelctCbProveedorOrden() {
      if (this.OrdenSugerida.proveedor == null) {
        this.OrdenSugerida.proveedor = "";
      }
      if (this.OrdenSugerida.proveedor.codigo == undefined) {
        this.alerta("Seleccione un proveedor", "error");
        this.OrdenSugerida.proveedor = "";
        return;
      }
    },

    ProveedorOrdenCompraObtenerDatoSelect(e) {
      this.ProveedorOrdenCompraDatostabla(e.item);
    },
    async ProveedorOrdenCompraDatostabla(e) {
      var _this = this;
      var Limpiar = new Promise((resolve, reject) => {
        this.ListProd = []
        this.ProveedorOrdenCompraSelected = [];
        this.FacturaProveedor.facturasProveedoresDetalleList = []

        setTimeout(() => {
          EventBus.$emit("loading", true);
          resolve('resolved');
        }, 200);
      });


      Limpiar.then(() => {
        if (this.ejecucion == true) {
          this.ListProd = []
          this.ProveedorOrdenCompraSelected = [];
          this.FacturaProveedor.facturasProveedoresDetalleList = []
          this.ProveedorOrdenCompraSelected.push(e);
          this.ejecucion = false
          var _this = this;
          setTimeout(function () {
            _this.continProveedorOrdenCompraDatostabla(e)
          }, 300);
        }
      });

    },

    async continProveedorOrdenCompraDatostabla(e) {
      if (e != null) {
        this.FacturaProveedor.empresa = e.empresa;
        this.FacturaProveedor.fecha = new Date(e.fecha)
          .toISOString()
          .substr(0, 10);
        this.FacturaProveedor.ordencompra = e.codigo;
        this.FacturaProveedor.totalimpuesto = e.impuesto;
        this.FacturaProveedor.totaldescuento = 0;
        this.FacturaProveedor.total = e.valor;
        this.FacturaProveedor.comentario = e.comentario;
        this.FacturaProveedor.tasa = e.tasa;
        this.FacturaProveedor.moneda = e.moneda;
        var LisOrden = JSON.parse(JSON.stringify(e.ordencompraDetalleList))

        await Promise.all(
          LisOrden.sort(function (a, b) {
            if (a.descripcion > b.descripcion) { return 1; }
            if (a.descripcion < b.descripcion) { return -1; }
            return 0;
          }));

        await Promise.all(
          LisOrden.map(async (el) => {
            var det = {
              facturasProveedoresDetallePK: {
                codigo: 0,
                documento: 0,
                unidad: 0,
                producto: 0,
                oferta: false,
              },
              fechavencimiento: null,
              cantidad: el.cantidad,
              precio: el.precio,
              descuento: el.descuento,
              impuesto: el.impuesto,
              valor: el.cantidad * el.precio,
              costo: el.precio,
              precioFactura: el.precio,
              impuestoIncluido: el.impuestoIncluido,
              descuentoPorciento: el.descuentoPorciento,
              borrado: false,
              almacen: el.almacen,
              productos: el.producto,
              unidades: el.unidad,
            };
            this.FacturaProveedor.facturasProveedoresDetalleList.push(det);
            this.$refs.detalle.addDetalleOrdenAFactura(det);
          })
        );

        /*  e.ordencompraDetalleList.forEach((el) => {
          });*/

      }
      this.dialogProveedorOrdenCompra = false;

      var _this = this;
      setTimeout(function () {
        EventBus.$emit("loading", false);
        _this.ejecucion = true
        _this.$refs.detalle.calcularTotales();
      }, 900);
      return;

    },



    OpenProveedorOrdenCompra() {
      this.dialogProveedorOrdenCompra = true;
    },
    BuscaOrdenCompra(e) {
      this.cargarOrdenCompra();
    },
    SelctCbProveedor() {
      if (this.FacturaProveedor.proveedor == null) {
        this.FacturaProveedor.proveedor = "";
      }
      if (this.FacturaProveedor.proveedor.codigo == undefined) {
        this.alerta("Seleccione un proveedor", "error");
        this.FacturaProveedor.proveedor = "";
        return;
      }
      //this.datosNCF.codigoFijo = this.FacturaProveedor.proveedor.codigoFijo;

      if (this.FacturaProveedor.proveedor.hasOwnProperty('codigoFijo') && this.FacturaProveedor.proveedor.codigoFijo != null) {
        this.datosNCF.codigoFijo = JSON.parse(JSON.stringify(this.FacturaProveedor.proveedor.codigoFijo.trim().toUpperCase()))
      }

      // this.FacturaProveedor.diascredito = this.FacturaProveedor.proveedor.diaCredito;
      this.tipogasto = this.FacturaProveedor.proveedor.gasto
      this.cargarOrdenCompra();
      if (this.FacturaProveedor.hasOwnProperty('diascredito') && this.FacturaProveedor.diascredito != null && this.FacturaProveedor.diascredito > 0) {
        this.FacturaProveedor.diascredito = this.FacturaProveedor.proveedor.diaCredito;
      } else {
        this.FacturaProveedor.diascredito = 30
      }


    },

    CbFilProveedor(e) {
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/proveedores/findallbyDesc/25/0/" +
            (e.target.value === "" ? "*" : e.target.value),
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
            this.Rproveedor = res.data

          });
      }
    },

    SelctCbMoneda() {
      if (this.FacturaProveedor.moneda == null) {
        this.FacturaProveedor.moneda = "";
      }
      if (this.FacturaProveedor.moneda.codigo == undefined) {
        this.alerta("Seleccione una moneda", "error");
        this.FacturaProveedor.moneda = "";
        return;
      }
      this.cambiarTasa();
    },
    cambiarTasa() {
      this.FacturaProveedor.tasa = this.FacturaProveedor.moneda.tasa;
    },
    cargarMoneda() {
      this.$axios
        .get(this.$hostname + this.$hName + "/monedas/findallActivos/", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.Rmoneda = res.data));
    },
    SelctCbProveedoresFiltro() {
      if (this.Modallfiltro.proveedores == null) {
        this.Modallfiltro.proveedores = "";
      }
      if (this.Modallfiltro.proveedores.codigo == undefined) {
        this.alerta("Seleccione un proveedores", "error");
        this.Modallfiltro.proveedores = "";
        return;
      }
    },
    SelctCbDocumentoFiltro() {
      if (this.Modallfiltro.documento == null) {
        this.Modallfiltro.documento = "";
      }
      if (this.Modallfiltro.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error");
        this.Modallfiltro.documento = "";
        return;
      }
    },

    ReportBlurDesde() {
      if (this.datosImprecionAll.desde.toString().length == 0) {
        this.datosImprecionAll.desde = this.fechaNueva();
      }
    },

    ReportBlurHasta() {
      if (this.datosImprecionAll.hasta.toString().length == 0) {
        this.datosImprecionAll.hasta = this.fechaNueva();
      }
    },

    SelctCbReportDocumento() {
      if (this.datosImprecionAll.documentos == null) {
        this.datosImprecionAll.documentos = "";
      }

      if (this.datosImprecionAll.documentos.codigo == undefined) {
        this.alerta("Seleccione un documento", "error");
        this.datosImprecionAll.documentos = "";
        return;
      }
    },

  async DDataTotalList(e) {
      this.TotalProd = JSON.parse(JSON.stringify(e));
    },

    abrirTabla2() {
      this.BarraSecundariaAprir = !this.BarraSecundariaAprir;
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
      if (this.BarraTablaDinamicaAprir == true) {
        this.Limpiarfiltro();
      }
    },

    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.Limpiarfiltro();
    },

    Limpiarfiltro() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      };

      this.Modallfiltro = {
        proveedores: null,
        factura: null,
        documento: null,
        Desde: null,
        Hasta: null,
      };

      this.ListItems = [];
      this.TbTotalItem = 0;

      this.TbPaginator = JSON.parse(JSON.stringify(Pg));
      this.CargarListTb();
      this.dialogFiltros = false;
    },

    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      };

      if (
        this.Modallfiltro.factura != null &&
        this.Modallfiltro.factura.toString().length == 0
      ) {
        this.Modallfiltro.factura = null;
      }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg));
      this.CargarListTb();
      this.dialogFiltros = false;
    },

    cargarPaginacionAll(e) {
      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15;
      }
      this.CargarPaginacion(e, this.Modallfiltro.factura);
    },

    CargarPaginacion(e, s) {
      this.Modallfiltro.factura = JSON.parse(JSON.stringify(s));

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15;
      }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e));
      this.CargarListTb();
    },

    CargarListTb() {
      var prove = null;
      var doc = null;
      if (this.Modallfiltro.proveedores != null) {
        prove = this.Modallfiltro.proveedores.codigo;
      }
      if (this.Modallfiltro.documento != null) {
        doc = this.Modallfiltro.documento.codigo;
      }
      
      var obj =
        this.TbPaginator.itemsPerPage +
        "/" +
        this.TbPaginator.pageStart +
        "/" +
        this.Modallfiltro.factura +
        "/" +
        prove +
        "/" +
        doc +
        "/" +
        this.Modallfiltro.Desde +
        "/" +
        this.Modallfiltro.Hasta;
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/facturasproveedor/findListFactProveedorPlus/" +
          obj,
          {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              searchByCodigo: this.searchByCodigo
            }
          }
        )
        .then((res) => {
          (this.ListItems = res.data.ListItems),
            (this.TbTotalItem = res.data.TbTotalItem);
        });
    },

    BlurCambioMayuscula() {
      if (this.datosNCF.codigoFijo.length > 0) {
        this.datosNCF.codigoFijo = JSON.parse(JSON.stringify(this.datosNCF.codigoFijo.toUpperCase()))
      }
    },

    openDialogCargerImagen() {
      this.dialogCargerImagen = true
      this.GetloaderCargarFoto()
    },

    getCargerImagen(codigofactura, documentofactura) {
      var LINK = `/facturasproveedor/findFacProFoto/${codigofactura}/${documentofactura}`
      this.$axios.get(this.$hostname + this.$hName + LINK, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.listObjFoto = res.data
        })
        .catch((error) => {
          this.newImagen()
        });
    },

    cerrarCargarImagen() {
      if (this.objCargaImg.imgView != null && this.objCargaImg.imgView.trim().length > 0) {
        this.FacturaProveedor.imagenFactura = this.objCargaImg.imgView
      }
      this.dialogCargerImagen = false
    },

    eliminarCargaImg(item) {
      const index = this.listObjFoto.indexOf(item);
      var eliminar = confirm("Desea eliminar esta imagen?") && this.listObjFoto.splice(index, 1);
      if (eliminar != false) {

        if (item.codigofactura > 0 && item.documentofactura > 0 && item.codigo > 0) {
          var obj = {
            cod: item.codigo,
            sec: item.codigofactura,
            doc: item.documentofactura,

          }

          this.$axios
            .post(
              this.$hostname +
              this.$hName + "/facturasproveedor/eliminarFacProFoto/", obj,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then(res => {
              if (res.data == true) {
                this.alerta("imagen eliminada corretamente", "bien2")
              } else {
                this.alerta("imagenn no eliminada", "error")
              }
              // this.newImagen()
              this.GetloaderCargarFoto()
            })
            .catch(error => {
              let msg = "";
              if (error.response) {
                msg = error.response.data
              } else if (error.request) {
                msg = error.request.data
              } else {
                msg = error.message;
              }
              this.alerta("Dato no anulado" + ": " + msg, "error")
            });
        }
      }
    },

    newImagen() {
      this.objCargaImg = {
        codigo: 0,
        codigofactura: 0,
        documentofactura: 0,
        cargaImg: null,
        imgView: '',
      }
      this.FacturaProveedor.imagenFactura = null
    },

    ConvertirImg(e) {
      var _this = this;

      // var filesSelected = document.getElementById("foto").files;
      var filesSelected = e
      if (filesSelected.length > 0) {
        var fileToLoad = filesSelected[0];

        var fileReader = new FileReader();

        fileReader.onload = function (fileLoadedEvent) {
          var srcData = fileLoadedEvent.target.result; // <--- data: base64

          var newImage = document.createElement("img");
          newImage.src = srcData;
          _this.objCargaImg.imgView = srcData;

          // document.getElementById("imgTest").innerHTML = newImage.outerHTML;
          // alert("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
          // console.log("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
        };
        fileReader.readAsDataURL(fileToLoad);
      } else {
        this.objCargaImg.imgView = '';
      }
      this.GetloaderCargarFoto()
    },

    addArchivoList() {
      if (this.$refs.formInputFileImg.validate()) {

        var newObj = {
          codigo: 0,
          codigofactura: 0,
          documentofactura: 0,
          imagen: this.objCargaImg.imgView,
        }

        this.listObjFoto.push(newObj);
        this.newImagen()

      } else {
        this.alerta("Los campos en rojo son requeridos", "error");
      }

    },

    // Llamar a una función en un componente secundario para los permisos de usuario.
    funcionValidaPermisoPv(e) {
      var Sudo = this.$store.getters.GetdatosInfUsu.usuario.sudo
      var permiso = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList

      //if (Sudo == false) { }
      var obj = {
        accion: JSON.parse(JSON.stringify(e)),
        Permiso: permiso,
        Sudo: Sudo
      }
      this.$refs.RefPvMenuOpcionBotones.ClickAccionPadreEjecut(obj)
    },

    DataRetornMenuOpcBotonesPermisosPv(e) {

    },

    DataRetornPadrePermisoPv(e) {
   
      //Permite Cambiar Cantidad a producto"
      if (e == 'AccModificarRegFacPro') {
        this.EjecutarPermisoPv = true
        var _this = this;
        var OBJDATA = JSON.parse(JSON.stringify(this.ObjEjecPermisoPv))
        this.ObjEjecPermisoPv = null
        setTimeout(function () {
          _this.saveCont();
          _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }


if (e == 'AccAnularRegistroProveedores') {
        this.EjecutarPermisoPv = true
        var _this = this;
        var OBJDATA = JSON.parse(JSON.stringify(this.ObjEjecPermisoPv))
        this.ObjEjecPermisoPv = null
        setTimeout(function () {
           _this.FacturaProveedor.usuarioAnulacion = JSON.parse(sessionStorage.getItem("usuarioAutorizacion"))
           _this.FacturaProveedor.fechaAnulacion = _this.fechaNueva() + "T04:00"
          _this.contAnulacion();
          _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }


    },

    GetloaderCargarFoto() {
      var _this = this;

      _this.loadercargarFoto = false
      setTimeout(function () {
        _this.loadercargarFoto = true
      }, 1000);

    },

    verificarYearfecha() {
      var _this = this;
      setTimeout(function () {
        //  if(e!=null && e.length>10){e='2024-12-10' }
        if (_this.FacturaProveedor.fecha != null && _this.FacturaProveedor.fecha.toString().length > 10) {
          var FCSPLIT = _this.FacturaProveedor.fecha.split("-")
          //var YEAR=FCSPLIT[0].substr(0,4)
          _this.FacturaProveedor.fecha = `${FCSPLIT[0].substr(0, 4)}-${FCSPLIT[1]}-${FCSPLIT[2]}`
        }
      }, 500);

    },
    ImprimirRestaurarFact(object) {
      var OBJ = {
        codigo: object.facturasProveedorestempPK.codigo,
        documento: object.facturasProveedorestempPK.documento
      }
      /*object.facturasProveedorestempPK.codigo
      object.facturasProveedorestempPK.documento*/

      EventBus.$emit("loading", true);
      this.$axios
        .post(
          this.$hostname +
          this.$hName +
          "/facturasproveedor/imprimirFactProTem",
          OBJ,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          EventBus.$emit("loading", false);
          setTimeout(function () {
            var PDF = `data:application/pdf;base64,${encodeURI(res.data)}`;
            EventBus.$emit("openPDF", PDF, 'Facturas de Proveedores Temporal');
          }, 1000);
        })
        .catch((error) => {
          EventBus.$emit("loading", false);
          console.error(error);
        });
    },

calcularDetalleMoneda(LISTA){

  console.log('Vineod-->',LISTA)
},

  GetCodigoProdUni(unidaproducto) {
      var pk = unidaproducto.facturasProveedoresDetallePK;
      var codigoP = ('000000' + pk.producto).substring(('000000' + pk.producto).length - 6, ('000000' + pk.producto).length)
      var codigoU = ('0000' + pk.unidad).substring(('0000' + pk.unidad).length - 4, ('0000' + pk.unidad).length)
      var codigoLote = "";

        if(unidaproducto.lote==null || unidaproducto.lote!=null &&  (""+unidaproducto.lote).trim().length== 0){
          unidaproducto.lote=0
        }

        if(unidaproducto.lote!=null&&typeof unidaproducto.lote === "string" && unidaproducto.lote.trim().length > 0){
            unidaproducto.lote = parseInt(unidaproducto.lote)
          }

      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        if (unidaproducto.lote !== "") {
          // codigoLote = unidaproducto.lote
          codigoLote = ('0000' + unidaproducto.lote).substring(('0000' + unidaproducto.lote).length - 4, ('0000' + unidaproducto.lote).length)
              
        }
      }

      var codigoBarra = codigoP + codigoU + codigoLote;
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote && codigoBarra.length > 14) {
        codigoBarra = codigoBarra.substring(0, 14)
      }
      return codigoBarra
    },



    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "bien2") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = true;
        EventBus.$emit("loading", false);
      }
    },

    async filtro() { },

    anularFacturaTemporal(factura){
      this.ejecucion = false
      EventBus.$emit("loading", true);
      let codigo = factura.facturasProveedorestempPK.codigo
      let documento = factura.facturasProveedorestempPK.documento

      this.$axios
          .delete(this.$hostname + this.$hName + `/facturasproveedor/anularTemporal/${codigo}/${documento}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Factura temporal borrada correctamente!", "bien2")
            this.Restaurartem()
            this.ejecucion = true
            EventBus.$emit("loading", false);
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Factura temporal no pudo ser borrada!", "error")
          });
    },
    NotifMessageNuevo() {
      var notif = {
        estado: true,
        nombre: "¿Está seguro de que desea crear un nuevo registro?",
        Exec: "NuevoFactPro",
      };
      this.Exec_notif(notif);
    },
  },

  computed: {
    paginaFacturaIaActiva() {
      if (!this.paginasFacturaIa.length)
        return null;
      if (this.indicePaginaFacturaIa < 0 || this.indicePaginaFacturaIa >= this.paginasFacturaIa.length)
        return this.paginasFacturaIa[0];
      return this.paginasFacturaIa[this.indicePaginaFacturaIa];
    },
    tamanoTotalPaginasFacturaIa() {
      return this.paginasFacturaIa.reduce((total, pagina) => total + (pagina.tamano || 0), 0);
    },
    puedeAgregarArchivosFacturaIa() {
      if (this.tipoArchivoFacturaIa === "PDF")
        return false;
      return this.paginasFacturaIa.length < this.maximoPaginasFacturaIa;
    },
    etiquetaCargaFacturaIa() {
      if (this.tipoArchivoFacturaIa === "PDF")
        return "PDF cargado. Quite el archivo para subir fotos";
      if (this.tipoArchivoFacturaIa === "IMAGEN")
        return "Agregar fotos (" + this.paginasFacturaIa.length + "/"
          + this.maximoPaginasFacturaIa + ")";
      return "PDF (1) o hasta " + this.maximoPaginasFacturaIa + " fotos JPG/PNG";
    },
    ayudaCargaFacturaIa() {
      return "Máximo " + this.maximoPaginasFacturaIa
        + " fotos o 1 PDF. No mezcle PDF + fotos. Tamaño máx. "
        + this.formatearTamanoArchivoIa(this.tamanoMaximoBytesFacturaIa) + ".";
    },
    ActDescBtn() {
      if (this.FacturaProveedor.facturasProveedoresPK.codigo > 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: this.modoIa ? this.haRevisadoFacturaIa : true,
          eliminar: false,
          anular: true,
          imprimir: true,
          vercuenta: true,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
          reimprimirEtiqueta: true,
          mostrarAnalisisIa: true
        };
        if (!this.FacturaProveedor.activada) {
          this.EstadoBtn.vercuenta = false;
          this.EstadoBtn.anular = false;
          this.EstadoBtn.guardar = false;
          this.EstadoBtn.reimprimirEtiqueta = false;
        }
        this.InputDisabled = true

      }

      if (this.FacturaProveedor.facturasProveedoresPK.codigo <= 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: this.modoIa ? this.haRevisadoFacturaIa : true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: true,
          guardartemporal: this.modoIa ? this.haRevisadoFacturaIa : true,
          restaurartemporal: true,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
          reimprimirEtiqueta: false,
          mostrarAnalisisIa: true
        };
        this.InputDisabled = false

      }

      this.windowSize = JSON.parse(
        JSON.stringify(this.$store.getters.GetwindowSize)
      );
    },
  },
};


</script>

<style></style>
